


rimg.shopify.init('[data-rimg="lazy"]', { round: 1 });

const sections = new ShopifySectionsManager();

sections.register("age-gate", (section) => new AgeGate.PageAgeGate(section));

const ageGatePage = document.getElementById("age-gate-page");

if (ageGatePage) {
  new AgeGate.SiteAgeGate(ageGatePage);
}

function checkAndToggleMessages() {
  const cartItemsElements = document.querySelectorAll('.cart_items');

  cartItemsElements.forEach(cartItemsElement => {
    const liElements = cartItemsElement.querySelectorAll('li');

    let bundleExists = false;

    liElements.forEach(li => {
      const CartDrawerbundleItems = li.querySelector('.minicart__bundle-items');
      if (CartDrawerbundleItems) {
        bundleExists = true;
      }
    });

    const messages = document.querySelectorAll('.mini-cart-bottom .minicart__message');

    messages.forEach(message => {
      if (bundleExists) {
        message.style.display = 'none';
      } else {
        message.style.display = 'block';
      }
    });
  });
}

// Function to execute the provided code
  function loadCart() {
    $.ajax({
      url: "/cart.js",
      dataType: "json",
      cache: false,
      success(cart) {
        const cartCountItem = document.querySelectorAll('.cart_count');
        cartCountItem.forEach((count) => {
          count.style.display = 'block';
        })
        
        setTimeout(() => {
          refreshCart(cart);
        },1000)

       setInterval(checkAndToggleMessages, 200);
        
      },
    });
  }
  // loadCart()
  // Event listener for document ready
  document.addEventListener('DOMContentLoaded', function() {
    loadCart();
  });

// Document ready
$(() => {
  let latestCartObject;
  window.utils.enableDisclosure();
  const oldFlickityCreate = window.Flickity.prototype._create;

  window.Flickity.prototype._create = function () {
    const that = this;
    if (this.element.addEventListener) {
      this.element.addEventListener(
        "load",
        () => {
          that.onresize();
        },
        true
      );
    }
    this._create = oldFlickityCreate;
    return oldFlickityCreate.apply(this, arguments);
  };

  // Support for background images with new Lazysizes library
  document.addEventListener("lazyloaded", (e) => {
    let bg = e.target.getAttribute("data-bg");
    const mobileBg = e.target.getAttribute("data-mobile-bg");
    if (bg) {
      if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
        bg = mobileBg;
      }
      e.target.style.backgroundImage = `url(${bg})`;
    }
  });

  // Call to flickity fix for sliders on IOS
  window.imageFunctions.flickityIosFix();

  window.objectFitImages();
  window.header.init();
  window.meganavManager.injectAll();
  if (window.PXUTheme.theme_settings.enable_autocomplete) {
    window.searchAutocomplete.init();
  }
  window.utils.initializeSectionWrapper();
  window.slideshow.init();
  window.testimonials.init();
  window.video.init();
  window.gallery.init();
  window.videoFeature.setupVideoPlayer();
  window.featuredPromotions.init();
  window.featuredCollection.init();
  window.logoList.init();
  window.collectionSidebarFilter.init();
  window.cart.init();
  window.map.init();
  window.shoppableImage.init();
  window.productPage.init();
  window.productPage.runOptionSelector();
  window.productPage.initializeQuantityBox();
  window.recentlyViewed.init();
  window.sidebarAccordions.init();

  if (
    window.PXUTheme.currency.show_multiple_currencies ||
    window.PXUTheme.currency.native_multi_currency
  ) {
    window.currencyConverter.init();
  }

  // Challenge page scroll

  // Return the pathname of the current URL
  const { pathname } = location;

  // If the pathname starts with '/challenge', animate scroll
  if (pathname.startsWith("/challenge")) {
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      "slow"
    );
  }

  // Setup a timer
  let resizeTimeout;
  // Grab screen width before screen is resized
  const beforeResizeWidth = $(window).width();

  // Listen for resize events
  window.addEventListener(
    "resize",
    () => {
      // If timer is null, reset it to 66ms and run your functions.
      // Otherwise, wait until timer is cleared
      if (!resizeTimeout) {
        resizeTimeout = setTimeout(() => {
          // Reset timeout
          resizeTimeout = null;
          // Grab screen width after screen is resized
          const currentScreenWidth = $(window).width();
          // Run our resize functions
          if (
            window.PXUTheme.media_queries.medium.matches &&
            currentScreenWidth !== beforeResizeWidth
          ) {
            window.cart.init();
            if (!window.is_touch_device()) {
              window.header.unload();
              window.header.init();
            }
          }

          window.logoList.init();

          // swap lazysizes background mobile images when browser is resized
          const lazysizesBackgroundImages =
            document.querySelectorAll("[data-bg]");
          lazysizesBackgroundImages.forEach((image) => {
            let bg = image.getAttribute("data-bg");
            const mobileBg = image.getAttribute("data-mobile-bg");

            if (bg) {
              if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
                bg = mobileBg;
              }

              image.style.backgroundImage = `url(${bg})`;
            }
          });
        }, 66);
      }
    },
    false
  );

  // Lightbox default options
  // https://fancyapps.com/fancybox/3/docs/#options
  $.fancybox.defaults.animationEffect = "fade";
  $.fancybox.defaults.transitionEffect = "fade";
  $.fancybox.defaults.hash = false;
  $.fancybox.defaults.infobar = false;
  $.fancybox.defaults.toolbar = false;
  $.fancybox.defaults.arrows = false;
  $.fancybox.defaults.loop = true;
  $.fancybox.defaults.smallBtn = true;
  $.fancybox.defaults.live = false;
  $.fancybox.defaults.zoom = false;
  $.fancybox.defaults.mobile.preventCaptionOverlap = false;
  $.fancybox.defaults.mobile.toolbar = true;
  $.fancybox.defaults.mobile.buttons = ["close"];
  $.fancybox.defaults.mobile.clickSlide = "close";
  $.fancybox.defaults.mobile.clickContent = "zoom";
  $.fancybox.defaults.afterLoad = function (instance, slide) {
    if (instance.current.type === "image") {
      slide.$content.wrapInner("<div class='fancybox-image-wrap'></div>");
    }
    if (instance.group.length > 1) {
      slide.$content
        .find(".fancybox-image-wrap")
        .append(
          `<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>${window.svgArrowSizeLeft}</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>${svgArrowSizeRight}</span></a>`
        );
    }
  };

  // backwards compatibility with custom lightboxes
  $('.lightbox[rel="gallery"]').fancybox();

  // Find youtube and vimeo iframes
  const $videoIframes = $(
    'iframe[src*="youtube.com"], iframe[src*="vimeo.com"], iframe[src*="facebook.com/plugins/video"]'
  );

  // legacy ImageUrl for Bundle Items
  function imgURL(src, size, center = false) {
    if (src === undefined || src === 'undefined') return
    // Remove any current image size then add the new image size
    let count = (src.match(/\.jpg|\.png|\.gif|\.jpeg/g) || []).length
    let centerVal = ''

    if (center) {
      centerVal = '_crop_center'
    }
    if (src === null) {
      return
    }
    if (count > 1) {
      return src
    }

    return src
      .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
      .replace(/\.jpg|\.png|\.gif|\.jpeg/g, match => {
        return '_' + size + centerVal + match
      })
  }

  // For each iframe, if parent is a responsive video wrapper do nothing
  // If no parent responsive video wrapper, then wrap iframe in responsive video wrapper

  function getAspectRatio(width, height) {
    const ratio = width / height;

    // Determine ratio to be used
    if (Math.abs(ratio - 1 / 1) === 0) {
      return "1:1";
    }
    return Math.abs(ratio - 4 / 3) < Math.abs(ratio - 16 / 9) ? "4:3" : "16:9";
  }

  $videoIframes.each((_index, iframe) => {
    // Update selector
    const $iframe = $(iframe);

    // Grab src
    const source = $iframe.attr("src");

    if (
      !$iframe.parents(".plyr__video-wrapper").length &&
      !$iframe.parents(".lazyframe").length
    ) {
      $iframe.wrap(
        `<div class="lazyframe" data-ratio="${getAspectRatio(
          $iframe.attr("width"),
          $iframe.attr("height")
        )}" data-src="${source}"></div>`
      );
    }
  });

  // Initiate lazyframe
  window.lazyframe(".lazyframe");

  // Wrap shopify policy in grid layout classes
  $(".shopify-policy__container").wrap(
    '<section class="section shopify-policy-template"><div class="container content"></div>'
  );

  // Add classes to determine column size
  // $(".shopify-policy__container").addClass(
  //   "five-eighths offset-by-three columns is-hidden-offset-mobile-only medium-down--one-whole"
  // );

  // Add featured divider beneath page title
  $(".shopify-policy__title").append('<div class="feature-divider"></div>');

  // Search input hiding
  // get current input
  const currentValue = $(".search__form input[name='q']").val();
  // return amount without *
  if ($(".search__form input[name='q']").length > 0) {
    $(".search__form input[name='q']").val(currentValue.replace("*", ""));
  }

  // Collection sorting

  const sortByEl = document.querySelector("[data-sort-by]");

  if (sortByEl) {
    sortByEl.addEventListener("change", (e) => {
      const { target } = e;
      const sortValue = target.value;
      if (target) {
        // Set the query string and redirect
        const queryString = new URLSearchParams(document.location.search);
        queryString.set("sort_by", sortValue);
        window.location.search = queryString;
      }
    });
  }

  $("body").on("change", "#tag_filter", () => {
    $("[data-option-filter] input").prop("checked", false);
    window.quickFilter.init();
  });

  $("body").on("change", "#blog_filter", function () {
    const url = $(this).val();
    window.location = url;
  });

  //  $("input, select, textarea").on("focus blur", (event) => {
  //    $("meta[name=viewport]").attr(
  //      "content",
  //      `width=device-width,initial-scale=1,maximum-scale=5`
  //    );
  // });

  // Collection sidebar filter
  // Check the checkbox values
  $("body").on("change", "[data-option-filter] input", () => {
    window.quickFilter.init();
    $("html, body").animate(
      {
        scrollTop: $(".content").offset().top,
      },
      500
    );
  });

  $("body").on("click", "[data-reset-filters]", () => {
    window.collectionSidebarFilter.clearAllFilters();
  });

  $("body").on("click", "[data-clear-filter]", (e) => {
    const $this = $(e.currentTarget);
    const selectedOption = $this.parents(".filter-active-tag");
    window.collectionSidebarFilter.clearSelectedFilter(selectedOption);
  });

  $("body").on("change", ".currencies", () => {
    $("[data-initial-modal-price]").attr("data-initial-modal-price", "");
  });

  $("body").on("change", ".js-quick-shop select", () => {
    const currentVariant = $('.js-quick-shop select[name="id"]').val();
    if (currentVariant && window.globalQuickShopProduct) {
      window.quickShop.updateVariant(currentVariant);
    }
  });

  if (window.PXUTheme.theme_settings.quick_shop_enabled) {
    window.quickShop.init();
  }

  let touchStartPos = 0;

  // Detecting swipe vs tap
  $(document)
    .bind("touchstart", () => {
      touchStartPos = $(window).scrollTop();
    })
    .bind("touchend", (e) => {
      const distance = touchStartPos - $(window).scrollTop();
      if (distance > 20 || distance < -20) {
        e.preventDefault;
      }
    });

  $("body").on("click", ".sidebar .parent-link--false", function (e) {
    e.preventDefault();
    const $menu = $(this).parent("li");
    $menu.find(".menu-toggle").toggleClass("active");
    $menu.find("ul").slideToggle();
  });

  if (window.PXUTheme.theme_settings.newsletter_popup) {
    window.newsletter_popup.init();
  }

  if (window.location.pathname.indexOf("/comments") !== -1) {
    $("html,body").animate(
      { scrollTop: $("#new-comment").offset().top - 140 },
      "slow"
    );
  }

  $("body").on("mouseenter", ".icon-search", () => {
    $(".search-terms").focus();
  });

  $("body").on("click", ".icon-search", () => {
    $("input.search-terms").focus();
  });

  $("body").on("click", ".search-submit", (e) => {
    const $this = $(e.currentTarget);
    $this.parent().submit();
  });

  if (window.PXUTheme.media_queries.large.matches) {
    $(".animate_right").waypoint(
      function () {
        $(this.element).addClass("animated fadeInRight");
      },
      { offset: "70%" }
    );
    $(".animate_left").waypoint(
      function () {
        $(this.element).addClass("animated fadeInLeft");
      },
      { offset: "70%" }
    );
    $(".animate_up").waypoint(
      function () {
        $(this.element).addClass("animated fadeInUp");
      },
      { offset: "70%" }
    );
    $(".animate_down").waypoint(
      function () {
        $(this.element).addClass("animated fadeInDown");
      },
      { offset: "70%" }
    );
  }

  // backwards compatibility with flexslider
  $(".slider, .flexslider").find("li").unwrap();
  $(".slider, .flexslider").flickity({
    pageDots: window.usePageDots,
    imagesLoaded: true,
    arrowShape: window.arrowSize,
    lazyLoad: 2,
  });

  window.utils.createAccordion(".footer_menu", "h3", "ul");
  window.utils.createAccordion(".footer_content", "h6", "div.toggle_content");
  window.utils.createAccordion(
    ".product_section .accordion-tabs",
    ".tabs li > a",
    ".tabs-content li"
  );
  window.utils.mobileParentActiveAccordion(
    "#mobile_menu",
    "li.sublink > a.parent-link--true span",
    "li.sublink ul"
  );
  window.utils.mobileAccordion(
    "#mobile_menu",
    "li.sublink > a.parent-link--false",
    "li.sublink ul"
  );

  window.utils.initializeTabs();
  window.accordion.init();

  $("body").on("click", ".menu-toggle", function () {
    const $content = $(this).next("ul");
    $content.slideToggle();
    $(this).toggleClass("active");
    $(this).attr(
      "aria-expanded",
      $(this).attr("aria-expanded") === "true" ? "false" : "true"
    );
  });

  if (window.PXUTheme.theme_settings.collection_swatches) {
    if (window.PXUTheme.media_queries.large.matches) {
      $("body").on("mouseenter", ".collection_swatches", function () {
        $(".swatch span", $(this)).each(function () {
          if ($(this).data("image").indexOf("no-image") === -1) {
            $("<img/>")[0].src = $(this).data("image");
          }
        });
      });
      $("body").on("mouseenter", ".swatch span", function () {
        if ($(this).data("image").indexOf("no-image") === -1) {
          $(this)
            .parents(".thumbnail")
            .find(".image__container img:not(.secondary)")
            .attr("src", $(this).data("image"));
          $(this)
            .parents(".thumbnail")
            .find(".image__container img:not(.secondary)")
            .attr("srcset", $(this).data("image"));
        }
      });
    }
  }

  // Terms of service settings for minicart
  if (window.PXUTheme.theme_settings.display_tos_checkbox) {
    $("body").on("click touchstart", ".cart_content .tos_label", function () {
      $(this).prev("input").prop("checked", true);
    });
  }

  if (
    window.PXUTheme.theme_settings.display_tos_checkbox &&
    window.PXUTheme.theme_settings.go_to_checkout
  ) {
    // Terms of service on mini-cart && cart page
    $("body").on(
      "click",
      ".tos_warning [data-cart-checkout-button]",
      function (e) {
        if ($(this).parents("form").find(".tos_agree").is(":checked")) {
          // Check if we are on the cart page or mini cart
          if (
            window.PXUTheme.theme_settings.go_to_checkout ||
            $("body").hasClass("cart")
          ) {
            $(this).submit();
          } else {
            // Redirect to cart page
            e.preventDefault();
            document.location.href = window.PXUTheme.routes.cart_url;
          }
        } else {
          const warning = `<p class="warning animated bounceIn">${window.PXUTheme.translation.agree_to_terms_warning}</p>`;
          if ($("p.warning").length === 0) {
            $(this).before(warning);
          }
          return false;
        }
      }
    );
  } else if (!window.PXUTheme.theme_settings.go_to_checkout) {
    $("body").on(
      "click",
      ".cart_content [data-minicart-checkout-button]",
      (e) => {
        // Redirect to cart page
        e.preventDefault();
        document.location.href = window.PXUTheme.routes.cart_url;
      }
    );
  }

  if (window.PXUTheme.theme_settings.collection_secondary_image) {
    window.imageFunctions.showSecondaryImage();
  }

  // Contact form checkbox validation
  if ($("[data-is-required]").length) {
    const $checkboxGroup = $(".custom-contact__checkbox");
    $checkboxGroup.prop("required", true);

    $checkboxGroup.on("change", () => {
      $checkboxGroup.prop("required", true);
      if ($checkboxGroup.is(":checked")) {
        $checkboxGroup.prop("required", false);
      }
    });
  }

  $(".maps").click(() => {
    $(".maps iframe").css("pointer-events", "auto");
  });

  // Load more / infinite load

  if (window.PXUTheme.theme_settings.pagination_type === "load_more") {
    window.enableLoadMoreProducts();
  }

  if (window.PXUTheme.theme_settings.pagination_type === "load_more_button") {
    window.enableLoadMoreButton(".product-list");
  }

  if (window.PXUTheme.theme_settings.pagination_type === "infinite_scroll") {
    window.enableInfiniteScroll(".product-list");
  }

  /*= ===========================================================================
    Start of cart-related functionality
  ============================================================================== */

  window.ajaxSubmitCart = (cart) => {
    const $cart = cart;
    $.ajax({
      url: "/cart/update.js",
      dataType: "json",
      cache: false,
      type: "post",
      data: $cart.serialize(),
      success(data) {
        refreshCart(data);
      },
    });
  };

  // async function handleCartUpdateSuccess(data, cartItem, reloadWindow) {
  //     console.log('cart items = ', data.items);
  //     let trElement = document.querySelector(`[data-variant-id="${cartItem.variantID}"]`);
  //     if(trElement){
  //     trElement.setAttribute('quantity', cartItem.quantity);
  //     let selectbox = trElement.querySelector('.cart__qty-select');
  //     if (selectbox) {
  //       const options = selectbox.options;
  //       for (let i = 0; i < options.length; i++) {
  //         if (parseFloat(options[i].value) === parseFloat(cartItem.quantity)) {
  //           options[i].setAttribute('selected','selected');
  //           } else {
  //             options[i].removeAttribute('selected');
  //           }
  //       }
  //     }
  //   }

  //   async function UpdateSubtotalExcludingGW() {
  //     let totalPriceGW = 0;
  //     let giftArrayOneGW = JSON.parse(localStorage.getItem('giftArray')) || [];
  //     let currencySymbolMarketLevel2GW = document.body.getAttribute('data-currency-symbol');
  //     let cartTotal;
  //     let subTotal;
  //     for (let i = 0; i < giftArrayOneGW.length; i++) {
  //         let priceAsNumberGW = parseFloat(giftArrayOneGW[i].giftProductPrice * giftArrayOneGW[i].giftproductQuantity); // convert string to number
  //         totalPriceGW += priceAsNumberGW;
  //     }
  //     await fetch('/cart.js')
  //       .then(response => response.json())
  //       .then((cart) => {

  //         if (window.location.href.includes('cart')) {
  //           const skioElements = document.querySelectorAll('skio-cart-upsell');
  //           skioElements && updateSKIOElements(skioElements, cart);
  //         }
          
  //           cartTotal = cart.total_price;
  //           if (totalPriceGW > 0) {
  //               subTotal = cartTotal - totalPriceGW;
  //           } else {
  //               subTotal = cartTotal;
  //           }
  //           // Retrieve the currency symbol from the body attribute
  //           let currencySymbolMarketLevel2 = document.body.getAttribute('data-currency-symbol');
            
  //           // Format the subtotal
  //           subTotal = (subTotal / 100).toFixed(2); // Convert cents to dollars and add two decimal places
            
  //           // Format the subtotal with the updated currency symbol
  //           subTotal = `${currencySymbolMarketLevel2}${subTotal}`;
                    
  //           let subtotalelement = document.querySelector('[data-cart-subtotal]');
  //           if(subtotalelement){
  //             subtotalelement.textContent = subTotal;
  //           }
            
  //       })
  //       // .catch(error => console.error('Error fetching cart:', error));
  //   }

  //   await UpdateSubtotalExcludingGW();
    
  //   // console.log('data_______')
  //   // console.log('===========',trElement,'===========');
  //   const cartItemsArray = data.items;
  //   const lineIDIndex = cartItem.lineID - 1;
  //   const totalCartItems =
  //     cartItem.parentCartForm.find("[data-variant-id]").length;
  //   const $quantityInputs = cartItem.parentCartForm.find(
  //     `[data-variant-id="${cartItem.variantID}"] input`
  //   );
  //   let initialQuantityTotal = 0;
  //   let apiQuantityTotal = 0;
  //   const apiLineItemQuantity =
  //     typeof data.items[lineIDIndex] !== "undefined"
  //       ? data.items[lineIDIndex].quantity
  //       : 0;

  //   // Check if item has a "Buy X get Y" deal
  //   if ($quantityInputs.length > 1) {
  //     // Multiple inputs

  //     // Get all the quantities of same variants in the cart (including BOGO) in HTML
  //     $.each($quantityInputs, (_i, input) => {
  //       initialQuantityTotal += parseInt($(input).val());
  //     });

  //     // Get quantities from cart object returned from API
  //     cartItemsArray.forEach((item) => {
  //       if (item.variant_id === cartItem.variantID) {
  //         apiQuantityTotal += item.quantity;
  //       }
  //     });
  //     if(reloadWindow == true){
  //       window.location.reload();
  //     } 
  //   } else {
  //     // Single input
  //     initialQuantityTotal = parseInt($quantityInputs.val());
  //     apiQuantityTotal =
  //       typeof data.items[lineIDIndex] !== "undefined"
  //         ? data.items[lineIDIndex].quantity
  //         : 0;
  //   }
  //   // await handleSelectChange(cartItem.quantity,cartItem.variantID);
  //   // Checks to see if there is enough inventory to update to an increased amount
  //   if (
  //     initialQuantityTotal > 0 &&
  //     initialQuantityTotal > apiQuantityTotal
  //   ) {
  //     if (apiQuantityTotal === 1) {
  //       itemsLeftText = window.PXUTheme.translation.one_item_left;
  //     } else {
  //       itemsLeftText = window.PXUTheme.translation.items_left_text;
  //     }

  //     $(".warning--quantity").remove();

  //     // Check if Buy one get one product
  //     // if (totalCartItems < cartItemsArray.length) {
  //     //   if (cartItem.parentCartForm.data("cart-form") === "cart-template") {
  //     //     // Refreshes cart if inventory is available
  //     //     cartItem.parentCartForm.submit();
  //     //   } else {
  //     //     refreshCart(data);
  //     //   }
  //     // } else {
  //       const warning = `<p class="warning warning--quantity animated bounceIn">${apiQuantityTotal} ${itemsLeftText}</p>`;
  //       cartItem.parentCartForm
  //         .find(`[data-line-id='${cartItem.lineID}'] input`)
  //         .parent()
  //         .after(warning);
  //       cartItem.parentCartForm
  //         .find(`[data-line-id='${cartItem.lineID}'] input`)
  //         .val(apiLineItemQuantity);
  //       refreshCart(data);
  //     // }
  //   } else if (
  //     cartItem.parentCartForm.data("cart-form") === "cart-template"
  //   ) {
  //     // Refreshes cart if inventory is available
  //     cartItem.parentCartForm.submit();
  //   } else {
  //     refreshCart(data);
  //   }
  // }

  window.updateCartItemQuantity = (cartItem, giftIdToRemove) => {
    let dataPayload = {};
    const body = document.querySelector('body');
    const moneyFormat = body.getAttribute('data-money-format');
    const currencySymbol = moneyFormat.match(/[^0-9.,\s\{\}]+/g)?.[0] || '';
    let reloadWindow = false;
    let url = '';

    if (giftIdToRemove) {
      // Use /cart/update.js for removing the gift
      dataPayload = {
        updates: {
          [giftIdToRemove]: 0, // Set gift quantity to 0 to remove it
          [cartItem.variantID]: cartItem.quantity // Keep the original item (if needed)
        }
      };
      
      url = '/cart/update.js';
 
    }else if (cartItem.skioProperty) {
      
      const totalSkioPrice = cartItem.quantity * cartItem.singleUnitSkioPrice;

      let skioDiscount = cartItem.skioProperty.replace(/\([^\d]*[\d.,]+\)/, `(${currencySymbol}${(totalSkioPrice / 100).toFixed(2)})`);
      cartItem.$element.attr("data-skio-properties", skioDiscount);

      dataPayload = {
        // Target by line index, not the line item key: Skio re-keys subscription lines
        // (via their Discount property) after render, so the rendered key is stale and a
        // key-based change.js returns 400. The line index survives re-keying and is kept
        // current by refreshCartID().
        line: cartItem.lineID,
        quantity: cartItem.quantity,
        properties: {
          'Discount': skioDiscount, // Add Skio discount property
          // Candle lid (PRO-15239): this call replaces the line's properties; keep its lid link
          ...(cartItem.lidPair ? { _lid_pair: cartItem.lidPair } : {}),
        }
      };
      console.log('test 1');

      url = '/cart/change.js'; 
      // if (window.location.href.includes('cart')) {
      //   reloadWindow = true;
      // }

    } else {
      dataPayload = {
        // Target by line index (consistent with the subscription branch): line item keys
        // can be re-keyed by apps (e.g. Skio) after render, making a key-based change.js
        // 400. The line index is kept current by refreshCartID().
        line: cartItem.lineID,
        quantity: cartItem.quantity,
        properties: cartItem.properties || {}
      };

      console.log('second call');
      // let {plusMinus, matchingParent, matchingChild} = getParentChild(cartItem, latestCartObject);
      console.log('from remove');
      
      console.log('test 2');
      url = '/cart/change.js'; 
    }
    
    console.log('dataPayload = ', dataPayload);
    // Execute the AJAX request
    $.ajax({
      url: url,
      dataType: "json",
      cache: false,
      type: "post",
      data: dataPayload,
      success: async (data) => {

        // Sync the attribute on the row that actually changed, not the first variant match
        // (which can be a different line — e.g. a subscription — sharing this variant).
        let trElement = (cartItem.$element && cartItem.$element[0])
          ? cartItem.$element[0]
          : document.querySelector(`[data-variant-id="${cartItem.variantID}"]`);
          if(trElement){
          trElement.setAttribute('quantity', cartItem.quantity);
          let selectbox = trElement.querySelector('.cart__qty-select');
          if (selectbox) {
            const options = selectbox.options;
            for (let i = 0; i < options.length; i++) {
              if (parseFloat(options[i].value) === parseFloat(cartItem.quantity)) {
                options[i].setAttribute('selected','selected');
                } else {
                  options[i].removeAttribute('selected');
                }
            }
          }
        }

        if (window.location.href.includes('cart')) {
          try {
            var skioElements = document.querySelectorAll('skio-cart-upsell');
            if (skioElements && typeof updateSKIOElements === 'function') updateSKIOElements(skioElements, data);
          } catch(e) {}
        }
        await syncOrderSummaryWithCart(data);
        
        // console.log('data_______')
        const cartItemsArray = data.items;
        const lineIDIndex = cartItem.lineID - 1;
        const totalCartItems =
          cartItem.parentCartForm.find("[data-variant-id]").length;
        const $quantityInputs = cartItem.parentCartForm.find(
          `[data-variant-id="${cartItem.variantID}"] input`
        );
        let initialQuantityTotal = 0;
        let apiQuantityTotal = 0;
        const apiLineItemQuantity =
          typeof data.items[lineIDIndex] !== "undefined"
            ? data.items[lineIDIndex].quantity
            : 0;

        // Check if item has a "Buy X get Y" deal
        if ($quantityInputs.length > 1) {
          // Multiple inputs

          // Get all the quantities of same variants in the cart (including BOGO) in HTML
          $.each($quantityInputs, (_i, input) => {
            initialQuantityTotal += parseInt($(input).val());
          });

          // Get quantities from cart object returned from API
          cartItemsArray.forEach((item) => {
            if (item.variant_id === cartItem.variantID) {
              apiQuantityTotal += item.quantity;
            }
          });
          if(reloadWindow == true){
            window.location.reload();
          } 
        } else {
          // Single input
          initialQuantityTotal = parseInt($quantityInputs.val());
          apiQuantityTotal =
            typeof data.items[lineIDIndex] !== "undefined"
              ? data.items[lineIDIndex].quantity
              : 0;
        }
        // await handleSelectChange(cartItem.quantity,cartItem.variantID);
        // Checks to see if there is enough inventory to update to an increased amount
        if (
          initialQuantityTotal > 0 &&
          initialQuantityTotal > apiQuantityTotal
        ) {
          if (apiQuantityTotal === 1) {
            itemsLeftText = window.PXUTheme.translation.one_item_left;
          } else {
            itemsLeftText = window.PXUTheme.translation.items_left_text;
          }

          $(".warning--quantity").remove();

          // Check if Buy one get one product
          // if (totalCartItems < cartItemsArray.length) {
          //   if (cartItem.parentCartForm.data("cart-form") === "cart-template") {
          //     // Refreshes cart if inventory is available
          //     cartItem.parentCartForm.submit();
          //   } else {
          //     refreshCart(data);
          //   }
          // } else {
            const warning = `<p class="warning warning--quantity animated bounceIn">${apiQuantityTotal} ${itemsLeftText}</p>`;
            cartItem.parentCartForm
              .find(`[data-line-id='${cartItem.lineID}'] input`)
              .parent()
              .after(warning);
            cartItem.parentCartForm
              .find(`[data-line-id='${cartItem.lineID}'] input`)
              .val(apiLineItemQuantity);
            refreshCart(data);
          // }
        } else if (
          cartItem.parentCartForm.data("cart-form") === "cart-template"
        ) {
          // Refreshes cart if inventory is available
          cartItem.parentCartForm.submit();
        } else {
          refreshCart(data);
        }
      },
    });
  };
 
  function updateSKIOElements(skioElements, cart) {
  skioElements.forEach((element) => {
    // Step 1: Find the closest parent row with class .cart__table-row
    let cartElement = element.closest('.cart__table-row');
    
    // Step 2: Get the variant ID from the closest cart row
    let cartElVariantID = cartElement ? cartElement.dataset.cartItemVariantId : null;
    
    if (cartElVariantID) {
      // Find the matching cart item by variant ID in the cart
      let matchingCartItem = cart.items.find(item => item.id == cartElVariantID);
      
      if (matchingCartItem) {
        // Step 3: Update the subtotal-{item.key} with item.original_line_price formatted as money
        let subtotalEl = document.querySelector(`#subtotal-${matchingCartItem.key}`);
        if (subtotalEl) {
          subtotalEl.textContent = formatMoney(matchingCartItem.original_line_price); // Assuming formatMoney() is available
        }

        // Step 4: Update subtotal-cap-{item.key} with selling_plan_allocation.compare_at_price * quantity
        let subtotalCapEl = document.querySelector(`#subtotal-cap-${matchingCartItem.key}`);
        if (subtotalCapEl && matchingCartItem.selling_plan_allocation) {
          let compareAtPriceTotal = matchingCartItem.selling_plan_allocation.compare_at_price * matchingCartItem.quantity;
          subtotalCapEl.textContent = formatMoney(compareAtPriceTotal); // Assuming formatMoney() is available
        }

        // Step 5: Find .line-item.selling-plan__discount-text > .Discount-Meta and store it
        let discountTextEls = cartElement.querySelectorAll('.line-item.selling-plan__discount-text');
        if (discountTextEls.length > 0) {
          discountTextEls.forEach((discountTextEl) => {
            let discountMetaEl = discountTextEl.querySelector('.Discount-Meta');
            if (discountMetaEl) {
              let discountMetaContent = discountMetaEl.textContent;
            }
          });
        } 
      }
    }
  });
}


/**
 * Updates SKIO elements based on the matching cart items.
 * 
 * Steps:
 * 1. Iterate through each skioElement.
 * 2. Find the closest cart row with class .cart__table-row for the current skioElement.
 * 3. Extract the variant ID and selling plan from the cart row's data attributes.
 * 4. Find the matching item in the cart using both the variant ID and the selling plan name.
 * 5. If a matching cart item is found:
 *    a. Format and replace the subtotal price in the cart display.
 *    b. Format and replace the compare-at price in the cart display.
 * 6. Update discount text if the element exists
 */
function updateSKIOElements(skioElements, cart) {
  skioElements.forEach((element) => {
    // Step 1
    let cartElement = element.closest('.cart__table-row');
    
    // Step 2
    let cartElVariantID = cartElement ? cartElement.dataset.cartItemVariantId : null;
    let cartElSellingPlan = cartElement ? cartElement.dataset.skioPlan : null;

    // Step 3
    let matchingCartItem = cart.items.find(item => 
      item.id == cartElVariantID && 
      item.selling_plan_allocation && // Check if selling_plan_allocation is present
      item.selling_plan_allocation.selling_plan.name === cartElSellingPlan
    );

    // Step 4
    if (matchingCartItem) {
      let moneyFormat = document.body.getAttribute('data-money-format');

      // Step 5
      let priceContainer = cartElement.querySelector('.cart__td-price');

      if (priceContainer) {
        let subtotalEl = priceContainer.querySelector('span[id^="subtotal-"]');
        let compareAtEl = priceContainer.querySelector('span[id^="subtotal-cap-"]');

        // Step 5a
        if (subtotalEl) {
          subtotalEl.textContent = Shopify.formatMoney(
            matchingCartItem.original_line_price,
            moneyFormat
          );
        }

        // Step 5b
        if (compareAtEl) {
          compareAtEl.textContent = Shopify.formatMoney(
            matchingCartItem.selling_plan_allocation.compare_at_price * matchingCartItem.quantity,
            moneyFormat
          );
        }
      }

      // Step 6
      let discountTextEls = cartElement.querySelectorAll('.cart__product .line-item.selling-plan__discount-text');

      discountTextEls.forEach((discountTextEl) => {
        let discountMetaEl = discountTextEl.querySelector('.Discount-Meta'); 
        let discountText = matchingCartItem.properties.Discount || ''; 

        if (discountMetaEl) {
          discountMetaEl.textContent = discountText; // Update discount text
        }
      });
    }
  });
}


  window.refreshCartID = () => {
    const cartItem = document.querySelectorAll(".cart__item");

    for (let i = 0; i < cartItem.length; i++) {
      const lineIndex = i + 1;
      const dataLineId = cartItem[i].querySelectorAll("[data-line-id]");

      for (let c = 0; c < dataLineId.length; c++) {
        dataLineId[c].dataset.lineId = lineIndex;
      }
    }
  };

  function makeBundleItems(cart) {
    // Pluck out the child items and remove them from the list of items
    if (cart.items) {
      let childItems = {};
      let realItems = {};
      Object.keys(cart.items).forEach((key) => {
        const item = cart.items[key];
        if (
          item.properties &&
          "_bundle" in item.properties &&
          !("_bundle_skus" in item.properties)
        ) {
          if (!(item.properties._bundle in childItems)) {
            childItems[item.properties._bundle] = [];
          }
          childItems[item.properties._bundle].push(item);
        } else {
          realItems[key] = item;
        }
      });
      // Assign the child items to the parent items
      Object.keys(realItems).forEach((key) => {
        if (
          realItems[key].properties &&
          "_bundle" in realItems[key].properties
        ) {
          if (childItems[realItems[key].properties._bundle]) {
            realItems[key].childItems =
              childItems[realItems[key].properties._bundle];
          }
        }
      });
      // Use the parent/child relationship as the actual items
      cart.items = realItems;
      cart.item_count = Object.keys(cart.items).length;
    }
    return cart;
  }

  async function deleteLoneBundleItems(data) {
    const bundleChildren = {}
    const bundleparents = []
    let deleteString = ''

    // separating the child and bundle items
    Object.values(data?.items).forEach(({id,properties}) => {
      if(properties.hasOwnProperty('_bundle_skus')){
        bundleparents.push(properties._bundle)
      }

      if(properties.hasOwnProperty('_bundle')){
        if(bundleChildren[properties._bundle])
          bundleChildren[properties._bundle] += `&updates[${id}]=0`
        else
          bundleChildren[properties._bundle] = `?updates[${id}]=0`
      }
    })

    // checking if any child item is present without parent item
    Object.keys(bundleChildren).forEach(bundleKey => {
      let bundleParentExits = bundleparents.includes(bundleKey)
      if(!bundleParentExits) {
        deleteString = `${deleteString}${bundleChildren[bundleKey]}`
      }
    })

    // if we have any child item without parent delete that
    if (deleteString != '') {
      fetch(`/cart/update.js?${deleteString.substring(1)}`)
      .then(res => res.json())
      .then(data => data)
      .catch(e => e)
    }

    return data
  }

  // this should only run on the search page (rebuy search results page)
  if( window.location.pathname.includes('/search') || window.location.pathname.includes('/collections')){
    // Debounce timer to prevent multiple simultaneous cart refreshes
    let rebuyCartRefreshTimeout = null;

    function handleRebuyCartAdd() {
      // Clear any pending refresh
      if (rebuyCartRefreshTimeout) {
        clearTimeout(rebuyCartRefreshTimeout);
      }
      
      // Debounce: wait 300ms then fetch latest cart from server
      // This ensures we get the most up-to-date cart state, not stale Rebuy.Cart.cart
      rebuyCartRefreshTimeout = setTimeout(function() {
        // Fetch cart from server instead of using Rebuy.Cart.cart (which might be stale)
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            refreshCart(cart); 
            $('html').addClass('cart-active');
            
            // Scroll cart to the top
            const cartContent = (window.getCartDrawerElement && window.getCartDrawerElement())
              || document.querySelector('.cart_content');
            if (cartContent && typeof cartContent.scrollTo === 'function') {
              cartContent.scrollTo(0, 0);
            }

            if (typeof window.focusCartDrawer === 'function') {
              window.focusCartDrawer({ delay: 150 });
            }
          })
          .catch(error => {
            console.error('Error fetching cart:', error);
            // Fallback to Rebuy.Cart.cart if fetch fails
            if (Rebuy && Rebuy.Cart && Rebuy.Cart.cart) {
              refreshCart(Rebuy.Cart.cart);
              $('html').addClass('cart-active');
            }
          });
        
        rebuyCartRefreshTimeout = null;
      }, 300); // 300ms delay to debounce multiple rapid additions
    }

    document.addEventListener("rebuy:smartsearch.resultsPage.add", handleRebuyCartAdd);
    document.addEventListener("rebuy:smartcollections.add", handleRebuyCartAdd);
  }

  // Rebuy initialization helper
  window.initRebuy = function() {
    setTimeout(function(){
      if(window.Rebuy){ 
        Rebuy.init(); 
      }
    }, 500);
  };

  // Custom function to navigate to search page with input text
  window.navigateToSearchPage = function(searchTerm) {
    // routes to search page on different markets
    let marketURLSearch = '';
    if(window.location.pathname.includes('-eu') || window.location.pathname.includes('-gb')){
      marketURLSearch = window.location.pathname.split('/')[1];
    }
    
    const base = marketURLSearch ? `/${marketURLSearch}` : '';

    if (!searchTerm || searchTerm.trim() === '') {
      // If no search term, go to search page without query
      window.location.href = `${base}/search`;
    } else {
      // Encode the search term and navigate to search page
      const encodedTerm = encodeURIComponent(searchTerm.trim());
      window.location.href = `${base}/search?q=${encodedTerm}`;
    }
  };

  // ADA cart focus: capture the cart control the user just activated (qty +/-, quantity input,
  // remove, and the Skio subscription toggle) so focus can be returned to it after the drawer
  // re-renders, instead of dropping to the top of the cart. Fully fail-safe (never throws).
  // The key persists across calls (Skio fires refreshCart twice per subscription change, and the
  // 2nd fires with focus already on <body>) and is bounded by a timestamp so it never goes stale.
  var __cartFocusKey = null;
  function captureCartFocusKey() {
    try {
      var el = document.activeElement;
      if (!el || el === document.body || !el.closest) return null;
      var drawer = el.closest('[data-cart-drawer-main]');
      if (!drawer || !drawer.contains(el)) return null;
      var lineItem = el.closest('[data-cart-item]');
      var lineId = lineItem ? lineItem.getAttribute('data-line-id') : null;
      // Shadow-DOM control (the Skio subscription toggle lives inside <skio-cart-upsell>'s shadow
      // root): document.activeElement only ever reports the host, so capture host + shadow control.
      if (el.shadowRoot && el.shadowRoot.activeElement) {
        var deep = el.shadowRoot.activeElement;
        var scls = Array.prototype.filter.call(deep.classList || [], function (c) { return !/^is-|active|focus|hover|disabled/.test(c); })[0];
        return { inShadow: true, lineId: lineId, hostSel: el.tagName.toLowerCase(), shadowSel: deep.tagName.toLowerCase() + (scls ? '.' + scls : '') };
      }
      var sel;
      if (el.hasAttribute('data-func')) sel = '.js-change-quantity[data-func="' + el.getAttribute('data-func') + '"]';
      else if (el.hasAttribute('data-cart-quantity-input')) sel = '[data-cart-quantity-input]';
      else if (el.hasAttribute('data-remove-item')) sel = '[data-remove-item]';
      else if (el.tagName === 'SELECT') sel = 'select';
      else {
        var cls = Array.prototype.filter.call(el.classList, function (c) { return !/^is-|active|focus|hover/.test(c); })[0];
        sel = el.tagName.toLowerCase() + (cls ? '.' + cls : '');
      }
      var scope = lineItem || drawer;
      return {
        lineId: lineId,
        sel: sel,
        localIndex: Math.max(0, Array.prototype.indexOf.call(scope.querySelectorAll(sel), el)),
        globalIndex: Math.max(0, Array.prototype.indexOf.call(drawer.querySelectorAll(sel), el))
      };
    } catch (e) { return null; }
  }

  function visibleCartDrawer() {
    return Array.prototype.filter.call(
      document.querySelectorAll('[data-cart-drawer-main]'),
      function (d) { var r = d.getBoundingClientRect(); return r.width > 10 && r.height > 10; }
    )[0] || null;
  }

  // Focus the acted-on control once. Returns the focused element, or null if it isn't ready yet
  // (so the caller retries). allowFallback=true (final attempt) permits a non-exact fallback.
  function focusCartTarget(key, allowFallback) {
    var drawer = visibleCartDrawer();
    if (!drawer) return null;
    // Shadow-DOM control (Skio subscription): the control inside <skio-cart-upsell>'s shadow root
    // changes type across the action (button "Start your Subscription" <-> <select> frequency /
    // one-time), and Skio re-renders it asynchronously — so match the captured selector, else the
    // first focusable in the shadow root, and return null (retry) until it exists.
    if (key.inShadow) {
      var liS = key.lineId ? drawer.querySelector('[data-cart-item][data-line-id="' + key.lineId + '"]') : null;
      var host = (liS || drawer).querySelector(key.hostSel);
      if (host && host.shadowRoot) {
        var t = (key.shadowSel && host.shadowRoot.querySelector(key.shadowSel))
          || host.shadowRoot.querySelector('button, a[href], input, select, [role="button"], [tabindex]:not([tabindex="-1"])');
        if (t && typeof t.focus === 'function') { t.focus(); return t; }
      }
      if (!allowFallback) return null; // shadow control not (re)rendered yet -> retry
      var fb = liS && liS.querySelector('.js-change-quantity, [data-cart-quantity-input], [data-remove-item]');
      if (fb) { fb.focus(); return fb; }
      var cx = drawer.querySelector('.minicart__close'); if (cx) { cx.focus(); return cx; }
      return null;
    }
    var target = null;
    if (key.lineId) {
      var li = drawer.querySelector('[data-cart-item][data-line-id="' + key.lineId + '"]');
      if (li) { var m = li.querySelectorAll(key.sel); target = m[key.localIndex] || m[0]; }
    } else {
      var d0 = drawer.querySelectorAll(key.sel);
      target = d0[key.globalIndex] || d0[0];
    }
    if (!target) {
      // The acted-on line item is gone (e.g. after Remove): focus the control now in the same
      // position, else the last one of its kind, else the cart close button.
      var all = drawer.querySelectorAll(key.sel);
      target = all[key.globalIndex] || all[all.length - 1] || drawer.querySelector('.minicart__close');
    }
    if (target && typeof target.focus === 'function') { target.focus(); return target; }
    return null;
  }

  var __restoreToken = 0;
  // Restore focus after the drawer re-renders, retrying through the Skio subscription toggle's
  // async shadow re-render. Only acts while focus is "lost" (on <body> or outside the drawer),
  // so it never yanks focus the user deliberately moved; a newer refreshCart supersedes this loop.
  function restoreCartFocus(key) {
    if (!key || (Date.now() - (key.ts || 0)) > 3000) return;
    var myToken = ++__restoreToken;
    var attempts = 0;
    var MAX = 9;
    (function attempt() {
      if (myToken !== __restoreToken) return; // superseded by a newer restore
      attempts++;
      try {
        var ae = document.activeElement;
        var focusLost = !ae || ae === document.body || !ae.closest || !ae.closest('[data-cart-drawer-main]');
        if (focusLost) focusCartTarget(key, attempts >= MAX);
      } catch (e) {}
      if (attempts < MAX) setTimeout(attempt, 130);
    })();
  }

  window.refreshCart = async (cartData) => {
    // Candle lid (PRO-15239): keep candle + lid pairs in step, then render the updated cart
    const cartWithSyncedLids = await syncCandleLids(cartData);
    if (cartWithSyncedLids) return window.refreshCart(cartWithSyncedLids);

    var __k = captureCartFocusKey();
    if (__k) { __k.ts = Date.now(); __cartFocusKey = __k; }
    // let filteredData = await deleteLoneBundleItems(cartData)

    let cart = makeBundleItems(cartData);
    latestCartObject = cart;
    console.log('latestCartObject', latestCartObject.items);
    $(".cart_count").empty();
    const $cartBtn = $(".cart_count");
    const value = $cartBtn.text() || "0";
    let cartItemsHTML = "";
    let cartDiscountsHTML = "";
    let cartActionHTML = "";
    let cartSavingsHTML = "";
    const $cartForm = $("[data-cart-form]");
    let productHasSale = false;
    let productCompareAtPrice = 0;
    let productFinalPrice = 0;

    console.log('cart', cart);

    // Check if all items in cart are rise-gift-card type
    const hasOnlyRiseGiftCards = (() => {
      // If cart is empty, return false
      if (!cart.items || Object.keys(cart.items).length === 0) {
        return false;
      }
      
      // Check if ALL items are rise-gift-card
      return Object.values(cart.items).every(item => item.product_type === 'rise-gift-card');
    })();
    
    // Update visibility of CTAs based on cart content
    if (hasOnlyRiseGiftCards) {
      document.querySelectorAll('.minicart__message').forEach(el => {
        el.classList.add('hidden');
      });
      console.log('hasOnlyRiseGiftCards', hasOnlyRiseGiftCards);
      // Set up an interval to repeatedly check for and remove the sample-drawer-active class
      const classCheckInterval = setInterval(() => {
        const elementsWithClass = document.querySelectorAll('.cart_content[data-cart-drawer-main].sample-drawer-active');
        
        if (elementsWithClass.length > 0) {
          // If elements with the class exist, remove the class from each one
          elementsWithClass.forEach(el => {
            el.classList.remove('sample-drawer-active');
          });
          console.log('Removed sample-drawer-active class from', elementsWithClass.length, 'elements');
        } else {
          // If no elements with the class are found, clear the interval
          clearInterval(classCheckInterval);
          console.log('No more elements with sample-drawer-active class found, interval cleared');
        }
      }, 100); // Check every 100ms
      
      // Safety timeout to clear the interval after 5 seconds regardless
      setTimeout(() => {
        clearInterval(classCheckInterval);
        console.log('Safety timeout cleared the interval');
      }, 5000);
    } else {
      document.querySelectorAll('.minicart__message').forEach(el => {
        el.classList.remove('hidden');
      });
    }

    // Set an interval to check for bundle items every 500 milliseconds (0.5 seconds)
    setInterval(checkAndToggleMessages, 200);

    
      document.dispatchEvent(
      new CustomEvent("CartRefreshQuantity", { detail: cart.total_price })
      );
    
    ///// Update Cart Total amount //////
    var cartFormWrap = document.getElementById("cart_form");
    if(cartFormWrap){
      if (cartFormWrap.hasAttribute("data-cart-total")) {
        // Get the current value of the attribute
        var currentCartTotal = cartFormWrap.getAttribute("data-cart-total");
      
        // Update the attribute value
        var newCartTotal = cart.total_price; // Replace "new value" with the desired new value
        cartFormWrap.setAttribute("data-cart-total", newCartTotal);
      }
    }
    ///// Update Cart Total amount //////

    $cartForm.data("total-discount", cart.total_discount);
    $cartForm.data("cart-total", cart.total_price);

    // Calculate cart total items while excluding "Duster Bag" product type
    let cartTotalItems = Object.values(cart.items)?.reduce((totalQty, item) => {
      // Skip "Duster Bag" items when calculating total
      console.log("Product type:", item.product_type); // Debug to see what product types we have
      if(item.product_type !== "Duster Bag") {
        return item.quantity + totalQty;
      }
      return totalQty;
    }, 0) || 0;
    
    $cartBtn.text(value.replace(/[0-9]+/, cartTotalItems));

    if (cart.item_count === 0) {
      $(".js-empty-cart__message").removeClass("hidden");
      $cartForm.addClass("hidden");
    } else {
      $(".js-empty-cart__message").addClass("hidden");
      $cartForm.removeClass("hidden");

      let totalSaving = 0; // adding counter variables for total cart savings
      let saving = 0;

      $.each(cart.items, (index, item) => {
        const itemDiscounts = item.discounts;
        let discountMessage = "";
        // Target the subtotal by the unique line key, not item.id (the variant id): two
        // lines can share a variant (e.g. subscription + one-time), and matching by
        // variant made this loop write one line's price onto the other line's subtotal.
        // Skip selling-plan (subscription) lines — they have a dedicated updater
        // (updateSKIOElements) that renders original_price × qty plus the compare-at
        // strikethrough; letting this generic loop overwrite them with final_line_price
        // produced a stale/half-quantity subtotal.
        const priceIDselector = item.selling_plan_allocation
          ? null
          : document.getElementById(`subtotal-${item.key}`);

        // An embroidered item or engraved lid shows its price with its hidden service line(s), so the
        // subtotal no longer drops back to the item alone after a refresh. Starts from the item's
        // final_line_price, like every other row, to keep any discount on the item (PRO-15607)
        const servicePrice = embroideryServicePrice(item, cart) + candleLidServicePrice(item, cart);
        const lineSubtotal = item.final_line_price + servicePrice * item.quantity;

        if (priceIDselector) priceIDselector.textContent = Shopify.formatMoney(lineSubtotal, document.body.getAttribute('data-money-format'));

        // Function to calculate percentage discount
        function calculateDiscountPercentage(originalPrice, discountedPrice) {
            let discount = originalPrice - discountedPrice;
            let percentage = (discount / originalPrice) * 100;
            return percentage;
        }
        
        // Example usage
        let originalPrice = item.price; // Replace with the original price
        let discountedPrice = item.discounted_price; // Replace with the discounted price
        
        let percentageDiscount = calculateDiscountPercentage(originalPrice, discountedPrice);

        var pt = item.product_title;
        var splitetitle = pt.split('-').shift();
        if (item.product_id !=4161049067613) {
        for (let i = 0; i < itemDiscounts.length; i++) {
          const { title } = itemDiscounts[i];
          discountMessage = `<p class="notification-discount meta">${title.toLowerCase()} <span class="discount-percentage-amount">(${percentageDiscount}% OFF)</span></p>`;
        }
      }
        const lineID = parseInt(index) + 1;
      
        // console.log(item.properties);
        // console.log('_embroidery_name' in item.properties);
        // ${item.product_type == 'Free Bag' ? 'style="display: none;"' : ''} 
        cartItemsHTML +=
          `<li class="mini-cart__item" data-cart-item data-line-id="${lineID}" data-product-type="${item.product_type}" data-gift-wrap-product="${item.properties?._gift_wrap}" data-wrap-product="${item.properties?._wrap_for}" data-variant-id="${item.id}" ${item.properties?._lid_pair ? `data-lid-pair="${escapeCandleLidHTML(item.properties._lid_pair)}"` : ''} ${item.properties?._embroidery_name ? `data-embroidery-item="true"` : ''} ${item.properties?._free_bag_for_sku ? `data-free-bag-item="true"` : ''} ${item.properties?._embroidery_services === 'true' && item.properties?._sync ? `data-service-type="embroidery-main" data-embroidery-sync="${item.properties?._sync}"` : ''} ${item.properties?._parent_sku && item.properties?._embroidery_name ? `data-service-type="embroidery-service"` : ''} ${item.properties?._parent_sku && item.properties?._lid_pair ? `data-service-type="engraving-service"` : ''} ${item.properties?._free_bag_for_sku ? `data-service-type="free-bag"` : ''}`
          if( item.product_type == 'Free Gift' || item.product_type == 'Sample' || item.product_type == 'rise-gift-card' || item.product_type == '1.5ml EDP Sampler Spray' ) {
            cartItemsHTML += `data-sample-freee-gift style="display: flex !important;"`;
          } 
          if (item.product_type == 'Sample') {
            cartItemsHTML += `style="display: none !important;"`;
          }
          if (item.properties && '_embroidery_name' in item.properties) {
            if('_parent_sku' in item.properties){
              cartItemsHTML += `embroidery-child`;
            }else if('_embroidery_child_sku' in item.properties){
              cartItemsHTML += `embroidery-parent`;
            }
          }
          if (item.selling_plan_allocation) {
            const plan = item.selling_plan_allocation;
            const skioOriginalPrice = plan.price;
            const skioCompareAtPrice = plan.compare_at_price;
            const itemQuantity = item.quantity;
            const skioItemPriceDifference = skioCompareAtPrice - skioOriginalPrice;
            const skioDiscountedPrice = (skioItemPriceDifference * itemQuantity) / 100;
            if (skioCompareAtPrice > skioOriginalPrice) {
              const skioDiscountPercentage = plan.selling_plan.price_adjustments[0].value;
              cartItemsHTML += `data-skio-properties="${skioDiscountPercentage}% off (${skioDiscountedPrice})"
                                data-single-unit-skio-price="${skioItemPriceDifference}">
                                `;
            }

          } else {
            cartItemsHTML += `>`;
          }
        cartItemsHTML+=
          `<div style="display:flex" role="group" aria-label="product"> ` +
          `<div class="mini-cart__item-element">`;
        if (item.image) {
          cartItemsHTML +=
            `${'<div class="cart_image" checking>' + '<img src="'}${item.image
              .replace(/(\.[^.]*)$/, "_compact$1")
              .replace("http:", "")}" alt="" />` +
            "</div></div>";
        }

        const retrievedBYOString = localStorage.getItem('BYOItems');
        const retrievedBYO = JSON.parse(retrievedBYOString);
          let quantity;
        let ItemPriceUpdates = item.price
        
          if (retrievedBYO != null) {
            retrievedBYO.map((x) => {
              if (x.handle === item.handle) {
                quantity = Math.floor(item.price / x.price);
                ItemPriceUpdates = x.price
              }
            });
          } else {
            // Handle the case where retrievedBYO is null or undefined
          }
        
        // Get the current URL
        const currentUrl_a = window.location.href;
      
      // Extract the domain from the current URL
      // Extract the protocol, domain, and market URL parts from currentUrl_a
      const protocol = currentUrl_a.split('/')[0];
      const domain_a = currentUrl_a.split('/')[2];
      var marketUrl_a = currentUrl_a.split('/')[3];
      
      // Construct the base URL using the extracted protocol
      let baseUrl_1 = `${protocol}//${domain_a}`;
      
      if (currentUrl_a.includes("-eu") || currentUrl_a.includes("-gb")) {
          baseUrl_1 += `/${marketUrl_a}`;
      }

      cartItemsHTML += `<div class="mini-cart__item-content">
            <div class="mini-cart__item-title">
              <a href="${baseUrl_1}${item.url}" class="mini-cart__item-product-title"><span class="mini-cart__item-product-name">${splitetitle}</span></a>
                <div class="minicart__item-row minicart__item-row--attr minicart__item-row--type" data-product-type="${item.product_type}">
                  <span class="minicart__label">Type:</span>
                  <span class="minicart__value">${item.product_type}</span>
                </div>
                ${
                  item.properties && item.properties._embroidery_services === 'true' 
                  ? `
                <div class="minicart__item-row--attr minicart__item-row--embroidery">
                  <span class="minicart__label-embroidery"><span class="minicart__bullet">•</span> Includes embroidery</span>
                  <span class="minicart__value-embroidery"><a href="#" class="embroidery-edit-link" data-embroidery-edit="${item.properties._sync}" data-embroidery-text="${item.properties.Embroidery || ''}">Edit</a></span>
                </div>
                  `
                  : ''
                }
                ${candleLidEngravingHTML(item)}
                <div class="minicart__item-row minicart__item-row--attr minicart__item-row--quantity hidden">
                  <span class="minicart__label">Qty:</span>
                  <span class="minicart__value">${quantity?quantity:item.quantity}</span>
                  </div>
            `;

        

        cartItemsHTML +=
          '</div><div class="minicart__item-row minicart__item-row--attr minicart__item-row--price minicart__value mini-cart__item-price"><span class="minicart__label">Price:</span> ';

      // Code for discount app
      
      async function fetchCompareAtPrice() {
        let productUrl = `/products/${item.handle}.json`;
      
        try {
          const response = await fetch(productUrl);
          const productData = await response.json();
      
          // Assign the compare_at_price of the first variant
          compareAtPrice = productData.product.variants[0].compare_at_price;
      
          // Check if compare_at_price is blank or null
          // if (!compareAtPrice) {
          //   console.log("compare_at_price is blank or null");
          // } else {
          //   console.log("compare_at_price:", compareAtPrice);
          // }
        } catch (error) {
          // console.error('There was a problem with the fetch operation:', error);
        }
      }
      
      // Function to find embroidery service items tied to this product via _sync property
      function findRelatedEmbroideryItems(item, cartItems) {
        // Skip if this is not a main product with _sync property
        if (!item.properties || !item.properties._sync) {
          return [];
        }
        
        // Ensure cartItems is iterable (convert object to array if needed)
        const itemsArray = Array.isArray(cartItems) ? cartItems : Object.values(cartItems || {});
        
        // Find all items with matching _sync property
        return itemsArray.filter(cartItem => 
          cartItem && 
          cartItem.id !== item.id && // Not the same item
          cartItem.properties && 
          cartItem.properties._sync && 
          cartItem.properties._sync === item.properties._sync
        );
      }
      
      // Calculate total price including embroidery services
      let totalItemPrice = ItemPriceUpdates;
      let embroideryItems = [];
      
      // If this is a main product with embroidery service
      if (item.properties && item.properties._embroidery_services === 'true') {
        embroideryItems = findRelatedEmbroideryItems(item, cart.items);
        // Add the price of all related embroidery items
        embroideryItems.forEach(embItem => {
          totalItemPrice += embItem.price;
        });
      }
      
      const itemPrice = window.Shopify.formatMoney(
        totalItemPrice,
        $("body").data("money-format")
      );
      const selling_plan_compare_at_price = window.Shopify.formatMoney(
        item?.selling_plan_allocation?.compare_at_price,
        $("body").data("money-format")
      );

      if (item.price > 0) {
        // Check if this is a main product with embroidery services
        let displayPrice = ItemPriceUpdates;
        if (item.properties && item.properties._embroidery_services === 'true' && item.properties._sync) {
          // Find embroidery service item with matching _sync code
          const syncCode = item.properties._sync;
          
          // Ensure cart.items is iterable (convert object to array if needed)
          const itemsArray = Array.isArray(cart.items) ? cart.items : Object.values(cart.items || {});
          
          const embroideryItems = itemsArray.filter(cartItem => 
            cartItem && 
            cartItem.id !== item.id && 
            cartItem.properties && 
            cartItem.properties._sync && 
            cartItem.properties._sync === syncCode
          );
          
          // Add embroidery service price to display price
          embroideryItems.forEach(embItem => {
            displayPrice += embItem.price;
          });
        }
        // Candle lid (PRO-15239): an engraved lid shows its price with the $5 engraving, like embroidery
        displayPrice += candleLidServicePrice(item, cart);
        
        // Format the combined price
        const displayPriceFormatted = window.Shopify.formatMoney(
          displayPrice,
          $("body").data("money-format")
        );
        
        cartItemsHTML += `
          <span class="money compare-money"><span class="sr-only">Current price: </span>${displayPriceFormatted}</span>
          ${
            item?.selling_plan_allocation?.compare_at_price > ItemPriceUpdates
              ? `<span class="money money-compare"><span class="sr-only">Original price: </span>${selling_plan_compare_at_price}</span>`
              : ''
          }
          </strong>`;
      }
      else{
          cartItemsHTML += `<span class="cart_free_text">${window.PXUTheme.translation.cart_free_text}</span></strong>`;
      }
      
      function renderPrice() {
        // Ensure `compareAtPrice` is defined before proceeding
        if (!compareAtPrice) {
          // console.warn("compareAtPrice is not defined. Skipping renderPrice.");
          return;
        }
      
        // Format item price using Shopify formatting
        const itemPrice = window.Shopify.formatMoney(
          ItemPriceUpdates,
          $("body").data("money-format")
        );
  
      
        const miniCartItems = document.querySelectorAll('li.mini-cart__item');
      
        miniCartItems.forEach((items) => {
          const dataVariantId = items.getAttribute('data-variant-id');
      
          if (dataVariantId.toString() === item.id.toString()) {
            const labelSpan = items.querySelector('.compare-money');
      
            if (labelSpan) {
              // Add the compare price only if `compareAtPrice` is available
              const priceSpan = document.createElement('span');
              priceSpan.className = 'money-compare';
              priceSpan.innerHTML = `<span>${window.Shopify.formatMoney(
                compareAtPrice,
                $("body").data("money-format")
              )} </span></strong>`;
      
              // Append the priceSpan after the labelSpan
              labelSpan.insertAdjacentElement('afterend', priceSpan);
            } else {
              // console.warn('.compare-money not found within matching <li>');
            }
          }
        });
      }
      
      
      fetchCompareAtPrice().then(() => {
        // console.log("compareAtPrice outside fetch:", compareAtPrice);
        renderPrice();
      });
  
        if (item.properties && item.selling_plan_allocation) {
          $.each(item.properties, (title, value) => {
            if (title.includes("Discount") && value) {
              
              const valueParts = value.split(' off');
              const beforeOff = valueParts[0];
              const afterOff = valueParts.length > 1 ? valueParts[1] : '';
              cartItemsHTML += `<div class="line-item subscription-discount-value"> ${beforeOff}<span class='off-word' style="font-family: 'Work Sans'; font-size: 13px; font-weight: 400; line-height: normal; letter-spacing: -0.05em;"> off</span> ${afterOff}</div>`;
            }
          });
        }

        if (item.properties) {
          $.each(item.properties, (title, value) => {
            if (title.includes("_recipient_name") && value) {
              cartItemsHTML += `<div class="line-item gift-cart-meta-data"><span>Name:</span> <span>${value}</span> </div>`;
            }
            if (title.includes("_recipient_email") && value) {
              cartItemsHTML += `<div class="line-item gift-cart-meta-data"><span>Email:</span> <span>${value}</span> </div>`;
            }
            if (title.includes("_gift_message") && value) {
              cartItemsHTML += `<div class="line-item gift-cart-meta-data"><span>Message:</span> <span>${value}</span> </div>`;
            }
          });
        }

        cartItemsHTML += "</div>";
        if (item.unit_price_measurement && item.price > 0) {
          let unitPriceMeasurementReferenceValue = "";

          if (item.unit_price_measurement.reference_value !== 1) {
            unitPriceMeasurementReferenceValue =
              item.unit_price_measurement.reference_value;
          }

          cartItemsHTML += `<p class="mini-cart__unit-price">${
            item.unit_price_measurement.quantity_value
          }${item.unit_price_measurement.quantity_unit} | ${Shopify.formatMoney(
            item.unit_price,
            $("body").data("money-format")
          )} / ${unitPriceMeasurementReferenceValue}${
            item.unit_price_measurement.reference_unit
          }</p>`;
        }

        if (
          item.properties &&
          ("_bundle_skus" in item.properties)
        ) {
          cartItemsHTML +=
          '<div class="minicart__gift-set-message">Not eligible for returns or promotions.</div>';
        }

        cartItemsHTML += discountMessage;
        // if (item.price > item.final_price) {
        //   cartItemsHTML += discountMessage;
        // }

        if ( item.product_type === "custom Discovery Set" || item.product_type === "Custom Gift Set" ) {
          cartItemsHTML +=`<div class="minicart__item-row minicart__item-row--attr minicart__item-row--quantity">
                    <span class="minicart__label_qty">Qty:</span>
                    <span class="minicart__value aa">${quantity?quantity:item.quantity}</span>
                  </div>`;
        } else {
          // Check if this is a main product with embroidery services
          const isEmbroideryMainProduct = item.properties && item.properties._sync;
          const embroideryDataAttr = isEmbroideryMainProduct ? `data-embroidery-main="${item.properties._sync}"` : '';
          
          cartItemsHTML += '<div class="product-quantity-box">';
          cartItemsHTML += `<label class="visually-hidden" for="updates_${item.id}">Quantity for ${splitetitle.trim()}</label>`;
          cartItemsHTML +=
            `<span class="ss-icon product-minus js-change-quantity" data-func="minus" role="button" tabindex="0" data-toggle-tabindex="" aria-label="Decrease quantity for ${splitetitle.trim()}"${embroideryDataAttr}><span class="icon-minus" aria-hidden="true"></span></span>`;
          cartItemsHTML += `<input type="number" min="0" class="quantity" name="updates[]" id="updates_${item.id}" value="${item.quantity}" data-cart-quantity-input="mini-cart" ${embroideryDataAttr} readonly/>`;
          cartItemsHTML +=
            `<span class="ss-icon product-plus js-change-quantity" data-func="plus" role="button" tabindex="0" data-toggle-tabindex="" aria-label="Increase quantity for ${splitetitle.trim()}"${embroideryDataAttr}><span class="icon-plus" aria-hidden="true"></span></span>`;
          cartItemsHTML += "</div>";
        }
        
        let remove_url = `/cart/change?quantity=0&id=${item.key}`;
        if (item.properties && // bundle parent
          ("_bundle_skus" in item.properties)
        ) {
          remove_url = '/cart/update?_=1';
          item.childItems.forEach((childItem) => {
            if (childItem.properties._bundle == item.properties._bundle) {
              remove_url += `&updates['${childItem.key}']=0`
            }
          })
        }

        

        let itemObject = JSON.stringify(item);
        itemObject = itemObject.replace(/&/g, "&amp;")
                                .replace(/</g, "&lt;")
                                .replace(/>/g, "&gt;")
                                .replace(/"/g, "&quot;")
                                .replace(/'/g, "&#39;");

        let pathName = window.location.pathname
        if (pathName.startsWith('/')) {
          pathName = pathName.substring(1);
        }
        let URLparts = pathName.split('/');
        let MarketIdentyfire = URLparts[0];
        if(MarketIdentyfire.includes('-eu') || MarketIdentyfire.includes('-gb')){
          cartItemsHTML += `<div class="minicart__item-row minicart__item-row--remove">
                              <a href="${remove_url}" title="Remove item" role="button" tabindex="0" data-toggle-tabindex="" class="minicart__remove" data-line-id="1" data-remove-item="mini-cart">Remove</a>
                            </div>
                            </div>
                            </div>`;
        } else{

          cartItemsHTML += `<div class="minicart__item-row minicart__item-row--remove">
                              <a href="${remove_url}" title="Remove item" role="button" tabindex="0" data-toggle-tabindex="" class="minicart__remove" data-line-id="1" data-remove-item="mini-cart">Remove</a>
                            </div>
                            <skio-cart-upsell item='${itemObject}' line='${index}'></skio-cart-upsell>
                            </div>
                            </div>`;
        }


        if (item.childItems?.length > 0) {
          cartItemsHTML += `<ul class="minicart__bundle-items">`;
          item.childItems.forEach((childItem) => {
            cartItemsHTML += `<li class="bundle-item">
              <a href="${childItem.url}" class="bundle-item__image-wrap">
               
                <img src="${imgURL(childItem.image, '150x')}" alt="${
                  childItem.title + " Product Image"
                }" class="bundle-item__image">

                
              </a>

              <div class="bundle-item__details">
                <div class="bundle-item__item-row bundle-item__item-row--name">
                  <a href="${childItem.url}" class="bundle-item__name">${childItem.title
                    .split("-")[0]
                    ?.trim()}</a>
                </div>`;

            // if (childItem.product_type) {
            //   cartItemsHTML += `
            //     <div class="bundle-item__item-row bundle-item__item-row--attr bundle-item__item-row--type">
            //       <span class="bundle-item__label">Type:</span>
            //       <span class="bundle-item__value">${childItem.product_type}</span>
            //     </div>`;
            // }

            if (childItem.option2Name && childItem.option2Value) {
              cartItemsHTML += `
                <div class="bundle-item__item-row bundle-item__item-row--attr bundle-item__item-row--type bundle-item__item-row--option2">
                  <span class="bundle-item__label">${childItem.option2Name}</span>
                  <span class="bundle-item__value">${childItem.option2Value}</span>
                </div>`;
            }
            if (childItem.option1Name && childItem.option1Value) {
              cartItemsHTML += `
                <div class="bundle-item__item-row bundle-item__item-row--attr bundle-item__item-row--type bundle-item__item-row--option1">
                  <span class="bundle-item__label">${childItem.option1Name}</span>
                  <span class="bundle-item__value">${childItem.option1Value}</span>
                </div>`;
            }

            if (childItem.variant) {
              cartItemsHTML += `
                <div class="bundle-item__item-row bundle-item__item-row--attr bundle-item__item-row--variant">
                  <span class="bundle-item__label"></span>
                  <span class="bundle-item__value">${childItem.variant}</span>
                </div>`;
            }

            cartItemsHTML += `
            </div>
              </div>
            </li>
          `;
          });
          cartItemsHTML += `</ul>`;
        }
      });

      let cartDiscounts;
       if(cart.cart_level_discount_applications.length > 0) {
         
          cartDiscounts = cart.cart_level_discount_applications
        
       }else{
        // Assuming you have an object of items and not an array
        for (let key in cart.items) {
            if (cart.items[key].line_level_discount_allocations && cart.items[key].line_level_discount_allocations.length > 0) {
                cartDiscounts = cart.items[key].line_level_discount_allocations;
                break; // Stop the loop once we find our item
            }
        } 
          
       }
    

      if(cartDiscounts && cartDiscounts.length>0){
        let sumWithLoop = 0;
          for (let discount of cartDiscounts) {
              sumWithLoop += discount.amount;
        }
      for (let i = 0; i < cartDiscounts.length; i++) {
         let amount;
         let title;
        if(cart.cart_level_discount_applications.length > 0) {
          title = cartDiscounts[i].title ?cartDiscounts[i].title: cartDiscounts[i].discount_application.title;
          amount= cartDiscounts[i].total_allocated_amount? cartDiscounts[i].total_allocated_amount:sumWithLoop;
          amount = window.Shopify.formatMoney(
              amount,
             $("body").data("money-format")
          );
        }else{
             title=cartDiscounts[i].discount_application.title;
              let actual=cartDiscounts[i].discount_application.total_allocated_amount
              amount = window.Shopify.formatMoney(
              cart.total_discount,
              $("body").data("money-format")
            );
        }
       if(i==0){
        cartDiscountsHTML +='';
        cartDiscountsHTML += `<span class="cart_discounts--title"><span>
        <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
          <path d="M18 3h-5.7a2 2 0 0 0-1.4.6L3.6 11a2 2 0 0 0 0 2.8l6.6 6.6a2 2 0 0 0 2.8 0l7.4-7.5a2 2 0 0 0 .6-1.4V6a3 3 0 0 0-3-3Zm-2.4 6.4a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"/>
        </svg>  
        ${title}</span></span>`;
        cartDiscountsHTML += '<span class="cart_discounts--price">';
        cartDiscountsHTML += `-<span class="money">${amount}</span></span>`;
       }
      }
      }

      cartActionHTML += `<span class="money">${window.Shopify.formatMoney(
        cart.total_price,
        $("body").data("money-format")
      )}</span>`;
      totalSaving += cart.total_discount;
      if (window.PXUTheme.theme_settings.display_savings && totalSaving > 0) {
        cartSavingsHTML =
          `<span class="right"><span class="money">${window.Shopify.formatMoney(
            totalSaving,
            $("body").data("money-format")
          )}</span></span>` +
          `<span>${window.PXUTheme.translation.cart_savings_text}</span>`;
      } else {
        cartSavingsHTML = "";
      }
    }


    $(".js-cart_items").html(cartItemsHTML);
    $(".js-cart_discounts").html(cartDiscountsHTML);
    $(".js-cart_subtotal").html(cartActionHTML);
    $(".js-cart_savings").html(cartSavingsHTML);

    // Converting the currencies
    if (window.PXUTheme.currency.show_multiple_currencies) {
      window.currencyConverter.convertCurrencies();
    }

    // ADA cart focus: after the drawer DOM has been replaced, return focus to the control the
    // user acted on (setTimeout lets any post-render DOM work settle first).
    setTimeout(function () { restoreCartFocus(__cartFocusKey); }, 0);
  };



  async function handleSelectChange(quantity,parentId) {
    
    let giftArrayOne = JSON.parse(localStorage.getItem('giftArray')) || [];
    giftArrayOne = giftArrayOne.map(obj => {
      if (obj.productId === parentId.toString()) {
        obj.giftproductQuantity = quantity;
      }
      return obj;
    });


  
    localStorage.setItem('giftArray', JSON.stringify(giftArrayOne));
    let filteredArray = giftArrayOne.filter(obj => obj.productId === parentId.toString());
    let parentSkus  = filteredArray.map(obj => obj.parentSku);
    let giftWrapProducts = document.querySelectorAll('[parent-wrapping-sku]');
  
  
    // Create an array to store the updated objects
    let updatedFilteredArray = [];
  
    // Iterate over the elements
    for (let i = 0; i < giftWrapProducts.length; i++) {
      let skus = giftWrapProducts[i].getAttribute('parent-wrapping-sku');
      if (parentSkus.includes(skus)) {
        let keyAttribute = giftWrapProducts[i].getAttribute('key');
        const selectQTY = giftWrapProducts[i].querySelector('select.cart__qty-select');
        selectQTY.value = quantity;
  
        // Create a new object with the key property and push it to updatedFilteredArray
        updatedFilteredArray.push({
          ...filteredArray.find(obj => obj.productId === parentId.toString()), // Copy the existing properties
          key: keyAttribute, // Add the new property
        });
      }
    }
  
    // Update filteredArray with the updated objects
    filteredArray = updatedFilteredArray;
  
    if (filteredArray.length > 0) {
      for (const x of filteredArray) {
        const formData = new FormData();
        formData.append("id", x.key);
        formData.append("quantity", quantity);
  
        try {
          console.log('test 3');

          const response = await fetch("/cart/change.js", {
            method: "POST",
            body: formData
          });
  
        } catch (err) {
          // console.log(err);
        }
      }
    }
  
    let latestGiftArray = JSON.parse(localStorage.getItem('giftArray')) || [];
    if (latestGiftArray.length > 0) {
      var vipResult = (typeof getVipGiftWrapDisplayTotal === 'function')
        ? getVipGiftWrapDisplayTotal(window.giftWrapVipConfig || {}, latestGiftArray)
        : null;
      if (vipResult && vipResult.formattedWithSign) {
        var cartGiftTotalElement = document.querySelector('.js-cart_gifttotal');
        if (cartGiftTotalElement) cartGiftTotalElement.textContent = vipResult.formattedWithSign;
      }
    }
  }  


  $("body").on("change", "[data-cart-quantity-input]", async function () {
    const cartItem = {
      lineID: $(this).parents("[data-cart-item]").data("line-id"),
      variantID: $(this).parents("[data-cart-item]").data("variant-id"),
      quantity: $(this).val(),
      parentCartForm: $(this).parents("[data-cart-form]"),
      totalDiscount: $(this).parents("[data-cart-form]").data("total-discount"),
      $element: $(this).parents("[data-cart-item]"),
      productId: $(this).parents("[data-cart-item]").data("product-id"),
      singleUnitSkioPrice:$(this).parents("[data-cart-item]").data("single-unit-skio-price"),
      skioProperty: $(this).parents("[data-cart-item]").data("skio-properties"),
      // .attr, not .data: jQuery would turn an all-digit pair code into a number
      lidPair: $(this).parents("[data-cart-item]").attr("data-lid-pair"),
      cartItemKey: $(this).parents("[data-cart-item]").attr("key") // Get the cart item key from the DOM
    };
    
    // Check if this is an embroidery main product
    const embroiderySyncCode = $(this).attr('data-embroidery-main');
    
    // Disable button after click to prevent multiple clicks
    $(this)
      .parents(".product-quantity-box")
      .find(".js-change-quantity")
      .addClass("is-disabled");
      
    // Handle embroidery products sync
    if (embroiderySyncCode) {
      try {
        // Get all related embroidery items from the cart
        const response = await fetch('/cart.js');
        const cart = await response.json();
        
        // Convert cart.items to array if it's not already
        const itemsArray = Array.isArray(cart.items) ? cart.items : Object.values(cart.items || {});
        
        // Find all related items with the same sync code
        const relatedItems = itemsArray.filter(item => 
          item && 
          item.properties && 
          item.properties._sync === embroiderySyncCode &&
          item.variant_id !== cartItem.variantID // Exclude the main product that was just updated
        );

        // Find the main product in the cart
        const mainItem = itemsArray.find(item => 
          item && 
          item.variant_id === cartItem.variantID &&
          item.properties && 
          item.properties._sync === embroiderySyncCode
        );

        console.log('relatedItems = ', relatedItems);
        console.log('mainItem = ', mainItem);
        
        // If we found related items, update their quantities
        if (relatedItems.length > 0 && mainItem) {
          const updates = {};
          
          // Add main product to updates using its key
          updates[mainItem.key] = parseInt(cartItem.quantity);
          
          // Add all related items to updates
          relatedItems.forEach(item => {
            updates[item.key] = parseInt(cartItem.quantity);
          });
          
          // Update all quantities in one API call
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ updates }),
          }).then(response => response.json())
            .then(data => {
              // After the update, refresh the cart
              refreshCart(data);
              
              // ADDITIONAL: Update the embroidery subtotal price in the cart page
              if (window.location.pathname.includes('/cart')) {
                // Ensure data.items is treated as an array
                const dataItems = Array.isArray(data.items) ? data.items : Object.values(data.items || {});
                
                // Find the main product in updated cart
                let mainProduct;
                
                // If we have the cart item key, use it for exact matching
                if (cartItem.cartItemKey) {
                  console.log('Looking for item with key:', cartItem.cartItemKey);
                  mainProduct = dataItems.find(item => item.key === cartItem.cartItemKey);
                }
                
                // If not found by key, fall back to finding by variant_id and sync code
                if (!mainProduct) {
                  mainProduct = dataItems.find(item => 
                    item && 
                    item.variant_id === cartItem.variantID &&
                    item.properties && 
                    item.properties._embroidery_services === 'true' &&
                    item.properties._sync === embroiderySyncCode
                  );
                }
                
                // If we found the main product
                if (mainProduct) {
                  console.log('Found main product with sync code:', embroiderySyncCode);
                  
                  
                  
                  // Calculate embroidery service total price
                  let embroideryPrice = 0;
                  let embroideryServiceItems = [];
                  
                  dataItems.forEach(item => {
                    if (item && 
                        item.properties && 
                        item.properties._sync === embroiderySyncCode && 
                        item.variant_id !== cartItem.variantID) {
                      embroideryPrice += item.price;
                      embroideryServiceItems.push(item);
                    }
                  });
                  
                  console.log('Found embroidery service items:', embroideryServiceItems);

                  // Get the embroidery service items with the same sync code
                  embroideryServiceItems.forEach(embServiceItem => {
                    const embroideryItemId = embServiceItem.variant_id; // Get variant ID from embroidery service item
                    
                    // Find cart row with matching variant ID
                    const matchingCartRow = document.querySelector(`tr.cart__table-row[data-cart-item-variant-id="${embroideryItemId}"]`);
                    
                    if (matchingCartRow) {
                      // Find the quantity input with the matching embroidery sync code
                      const quantityInput = matchingCartRow.querySelector(`input[data-embroidery-main="${embroiderySyncCode}"]`);

                      console.log('quantityInput = ', quantityInput);
                      
                      if (quantityInput) {
                        // Update the quantity value to match the main product quantity
                        quantityInput.value = mainProduct.quantity;
                        // Also update the value attribute
                        quantityInput.setAttribute('value', mainProduct.quantity);

                        console.log('quantityInput.value = ', quantityInput.value);
                        
                        // Trigger change event to update cart
                        // const changeEvent = new Event('change', { bubbles: true });
                        // quantityInput.dispatchEvent(changeEvent);
                        
                        console.log('Updated quantity input for embroidery item:', embroideryItemId, 'with sync code:', embroiderySyncCode);
                      }
                    }
                  });
                  
                  // Calculate combined subtotal (main product + embroidery) * quantity
                  // We need to add the embroidery price for a single item, not the total
                  const combinedSubtotal = (mainProduct.price + embroideryPrice) * mainProduct.quantity;
                  
                  console.log('Main product price:', mainProduct.price / 100);
                  console.log('Embroidery service price:', embroideryPrice / 100);
                  console.log('Quantity:', mainProduct.quantity);
                  console.log('Combined subtotal calculation:', ((mainProduct.price + embroideryPrice) * mainProduct.quantity) / 100);
                  
                  // Format the price for display using Shopify's money format helper
                  const formattedPrice = window.Shopify.formatMoney(
                    combinedSubtotal,
                    $("body").data("money-format")
                  );
                  
                  // Update the subtotal in the DOM
                  let subtotalElement;
                  
                  // Try to find by specific cart item key first
                  if (cartItem.cartItemKey) {
                    subtotalElement = document.querySelector(`[data-embroidery-subtotal="${embroiderySyncCode}"][id="subtotal-${CSS.escape(cartItem.cartItemKey)}"]`);
                    console.log('Looking for subtotal with key selector:', `[data-embroidery-subtotal="${embroiderySyncCode}"][id="subtotal-${cartItem.cartItemKey}"]`);
                  }
                  
                  // Fall back to just sync code if needed
                  if (!subtotalElement) {
                    subtotalElement = document.querySelector(`[data-embroidery-subtotal="${embroiderySyncCode}"]`);
                    console.log('Falling back to general sync selector:', `[data-embroidery-subtotal="${embroiderySyncCode}"]`);
                  }
                  
                  if (subtotalElement) {
                    subtotalElement.textContent = formattedPrice;
                    console.log('Updated embroidery subtotal:', formattedPrice);
                  } else {
                    console.error('Could not find subtotal element to update');
                  }
                }
              }
              
              // ADDITIONAL: Update the free bag prices in the cart page
              if (window.location.pathname.includes('/cart')) {
                // Get all cart items
                const cartItems = Array.isArray(data.items) ? data.items : Object.values(data.items || {});
                
                // Process all items to find free bag main products
                cartItems.forEach(mainItem => {
                  if (mainItem && 
                      mainItem.properties && 
                      mainItem.properties._free_bag && 
                      mainItem.properties._sync) {
                    
                    const syncCode = mainItem.properties._sync;
                    
                    // Find all related free bag items
                    const freeBagItems = cartItems.filter(item => 
                      item && 
                      item.properties && 
                      item.properties._sync === syncCode && 
                      item.properties._free_bag_for_sku && 
                      item.variant_id !== mainItem.variant_id
                    );
                    
                    // Calculate total price of free bag items
                    let freeBagPrice = 0;
                    freeBagItems.forEach(item => {
                      freeBagPrice += item.price;
                    });
                    
                    // Calculate combined subtotal
                    const combinedSubtotal = (mainItem.price + freeBagPrice) * mainItem.quantity;
                    
                    // Format the price for display using Shopify's money format helper
                    const formattedPrice = window.Shopify.formatMoney(
                      combinedSubtotal,
                      $("body").data("money-format")
                    );
                    
                    // Find and update the subtotal element for this item
                    const subtotalElement = document.querySelector(`#subtotal-${CSS.escape(mainItem.key)}`);
                    if (subtotalElement) {
                      subtotalElement.textContent = formattedPrice;
                      console.log('Updated free bag subtotal:', formattedPrice);
                    }
                  }
                });
              }
              return;
            });
        }
        updateOrderSummary(data);
      } catch (error) {
        console.error('Error updating embroidery quantities:', error);
        // Continue with normal flow if there's an error
      }
    } else {
     
      let latestArray = JSON.parse(localStorage.getItem('giftArray')) || [];
               
        let result = latestArray.filter(obj => obj.productId === cartItem.variantID.toString());
        // Only run the gift-wrap quantity logic when the row whose qty actually changed is
        // itself the gift-wrapped line. giftArray is keyed by variant, so without this a line
        // that merely shares the variant (e.g. a subscription of the same product) would
        // match and wrongly open the gift-wrap popup on a plain quantity change.
        const changedRowIsGiftWrapped = cartItem.$element && cartItem.$element.attr('gift-wrapping') === 'true';
        if (result.length > 0 && changedRowIsGiftWrapped) {
          if(parseFloat(result[0].giftproductQuantity) === 1 && parseFloat(cartItem.quantity)===1){
            let trElement = document.querySelector(`[data-variant-id="${result[0].productId}"]`);
            let editButton = trElement.querySelector('.edit-trigger');
            if(editButton){
              // editButton.style.display='block'
            }
          }else{
            if(parseFloat(result[0].giftproductQuantity) != 1 || parseFloat(cartItem.quantity) !=1){
            let trElement = document.querySelector(`[data-variant-id="${result[0].productId}"]`);
            let editButton = trElement.querySelector('.edit-trigger');
            if(editButton){
              editButton.style.display='block'
            }
          }
          } 
         
        
          if (parseFloat(result[0].giftproductQuantity) > parseFloat(cartItem.quantity)) {
            validateGitWrapQuantity(cartItem);     
          } else {
            // Target the gift-wrapped line for this variant, not the first variant match
            // (which can be a subscription line sharing the variant). Keeps the row's
            // quantity + the edit popup's max in sync after a quantity change.
            let trElement = document.querySelector(`[data-variant-id="${cartItem.variantID}"][gift-wrapping="true"]`)
              || document.querySelector(`[data-variant-id="${cartItem.variantID}"]:not([data-skio-plan])`)
              || document.querySelector(`[data-variant-id="${cartItem.variantID}"]`);
            if (trElement) trElement.setAttribute('quantity', cartItem.quantity);

            let editButton = trElement ? trElement.querySelector('.edit-trigger') : null;
            if (editButton) {
              editButton.setAttribute('product-quantity', cartItem.quantity);
            }
            
            if(parseFloat(cartItem.quantity) != 1) {
              if(editButton){
                editButton.click();
              }
            }
              
            if(parseFloat(cartItem.quantity) === 1) {
  
              // Find the project where productId matches cartItem.variantid
              const matchingProject = latestArray.find(project => project.productId === cartItem.variantID.toString());
  
              // Retrieve the gift ID from the matching project
              const giftId = matchingProject.giftId;
  
              const formData = new FormData();
              formData.append("id", giftId);
              formData.append("quantity", 1);
              try {
                // GIFT WRAP
                console.log('test 4');
  
                const response = await fetch("/cart/change.js", {
                  method: "POST",
                  body: formData
                });
              } catch (error) {
                // console.error('An error occurred:', error);
              }
              let trElements = document.querySelectorAll(`[data-variant-id="${cartItem.variantID}"]`);
              if(trElements.length>0){
              trElements.forEach(async (trElement) => {
              let properties_parent = trElement.getAttribute('data-properties');
                let bundleProps = {};
                if (properties_parent) {
                let data = JSON.parse(properties_parent);
                // Filter the data array to include items with key "_wrap_for"
                data.filter(([key]) => key === '_wrap_for')
                  .forEach(([key, value]) => {
                    bundleProps[key] = value;
                  });
              }
  
              if(bundleProps._wrap_for === matchingProject.parentSku){
                trElement.setAttribute('quantity','1');
                let selectbox = trElement.querySelector('.cart__qty-select');
                if (selectbox) {
                  const options = selectbox.options;
                  for (let i = 0; i < options.length; i++) {
                    if (parseFloat(options[i].value) === parseFloat(1)) {
                        options[i].setAttribute('selected','selected');
                      } else {
                        options[i].removeAttribute('selected');
                      }
                  }
                }
              }
              // editButton.style.display='none';
              for (let i = 0; i < latestArray.length; i++) {
                if (latestArray[i].productId === cartItem.variantID.toString()) {
                  latestArray[i].giftproductQuantity = "1";
                  break; // Exit the loop once the object is found and updated
                }
              }
              // Update the local storage
              localStorage.setItem('giftArray', JSON.stringify(latestArray));
            });
            let variantID=cartItem.variantID.toString();
            
            var parentCartData2 = await updateParentProduct(latestArray,variantID,cartItem.quantity,cartItem.cartItemKey);
            updateOrderSummary(parentCartData2);
              let errorMessage = trElement.querySelector('.quantity-error-message');
              if(errorMessage){
                errorMessage.style.display='none';
              }
              }
            }
  
            updateCartItemQuantity(cartItem);
          } 
        } else {
          
          updateCartItemQuantity(cartItem)
        }
    }
    
  });

  function mappedSkus(giftArray,productId){
    let groupedArray = Object.values(giftArray.reduce((acc, obj) => {
    const { productId, giftsku } = obj;
    if (!acc[productId]) {
      acc[productId] = { productId, giftSkuArray: [] };
    }
    acc[productId].giftSkuArray.push(giftsku);
    return acc;
  }, {}));

    let found = groupedArray.find(obj => obj.productId === productId);
    return found ? found.giftSkuArray : [];
  }

async function getLineItemKey(parentProductId) {
  try {
    const response = await fetch('/cart.js', { cache: 'no-cache' });
    const data = await response.json();
    const lineItem = data.items.find((item) => item.variant_id == parentProductId);
    return lineItem.key;
  } catch (error) {
    // console.error('An error occurred:', error);
  }
}


async function updateParentProduct(latestArray, parentID,parentQuantity, parentLineKey) {
  let giftSkuArray = mappedSkus(latestArray, parentID);

  // Prefer the exact line key of the row being changed; only fall back to the variant
  // lookup (first match) when no key was passed. Without this a subscription line sharing
  // the variant could receive the gift-wrap properties + forced quantity.
  let parentkey = parentLineKey || await getLineItemKey(parentID);

  if(parentkey){
    // GIFT WRAP
    console.log('test 5');

    const url = "/cart/change.js";
  
    // const tr = document.querySelector(`tr.cart__table-row[data-variant-id="${parentID}"]`);
    // let key=tr.getAttribute('key');
    
    let product_data = {
      id: parentkey,
      quantity: parentQuantity,
      properties: { '_gift_wrap': true, "_gift_wrap_skus": giftSkuArray.join(','), "_gift_wrap_quantity": "1" }
    };
    // console.log('Product data', product_data)
    const secondResponse = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(product_data)
    });
    
    const secondData = await secondResponse.json();
    return secondData;
  }

}

 
  async function validateGitWrapQuantity(cartItem) {
    // Target the gift-wrapped line for this variant (not the first variant match, which
    // may be a subscription line sharing the variant and has no edit button → crash).
    let trElement = document.querySelector(`[data-variant-id="${cartItem.variantID}"][gift-wrapping="true"]`)
      || document.querySelector(`[data-variant-id="${cartItem.variantID}"]:not([data-skio-plan])`)
      || document.querySelector(`[data-variant-id="${cartItem.variantID}"]`);
    let editButton = trElement ? trElement.querySelector('.edit-trigger') : null;
    if (editButton) editButton.setAttribute('product-quantity', cartItem.quantity);
    if (trElement) trElement.setAttribute('quantity', cartItem.quantity);

    if(parseFloat(cartItem.quantity) != 1) {
      if(editButton){
        editButton.click();
      }
    }

    let latestArray = JSON.parse(localStorage.getItem('giftArray')) || [];
    if(parseFloat(cartItem.quantity) === 1) {

      // Find the project where productId matches cartItem.variantid
      const matchingProject = latestArray.find(project => project.productId === cartItem.variantID.toString());

      // Retrieve the gift ID from the matching project
      const giftId = matchingProject.giftId;

      const formData = new FormData();
      formData.append("id", giftId);
      formData.append("quantity", 1);

      try {
        // GIFT WRAP
        console.log('test 6');

        const response = await fetch("/cart/change.js", {
          method: "POST",
          body: formData
        });
      } catch (error) {
        // console.error('An error occurred:', error);
      }
      let trElements = document.querySelectorAll(`[data-variant-id="${giftId}"]`);
      if(trElements.length>0){
      trElements.forEach((trElement) => {
      let properties_parent = trElement.getAttribute('data-properties');
        let bundleProps = {};
        if (properties_parent) {
        let data = JSON.parse(properties_parent);
        // Filter the data array to include items with key "_wrap_for"
        data.filter(([key]) => key === '_wrap_for')
          .forEach(([key, value]) => {
            bundleProps[key] = value;
          });
      }
    
      if(bundleProps._wrap_for === matchingProject.parentSku){
        trElement.setAttribute('quantity','1')
        let selectbox = trElement.querySelector('.cart__qty-select');
        if (selectbox) {
          const options = selectbox.options;
          for (let i = 0; i < options.length; i++) {
            if (parseFloat(options[i].value) === parseFloat(1)) {
                options[i].setAttribute('selected','selected');
              } else {
                options[i].removeAttribute('selected');
              }
          }
        }
      }
      editButton.style.display='none';
      for (let i = 0; i < latestArray.length; i++) {
        if (latestArray[i].productId === cartItem.variantID.toString()) {
          latestArray[i].giftproductQuantity = "1";
          break; // Exit the loop once the object is found and updated
        }
      }
      // Update the local storage
      localStorage.setItem('giftArray', JSON.stringify(latestArray));
    });
    let variantID=cartItem.variantID.toString();
    var parentCartData = await updateParentProduct(latestArray, variantID,cartItem.quantity,cartItem.cartItemKey);
    updateOrderSummary(parentCartData);
    let errorMessage = trElement.querySelector('.quantity-error-message');
    if(errorMessage){
      errorMessage.style.display='none';
    }
    }
  }
  updateCartItemQuantity(cartItem);
}


function updateOrderSummary(cartData) {
  var giftArrayOne = JSON.parse(localStorage.getItem('giftArray')) || [];
  if (typeof getVipGiftWrapDisplayTotal === 'function') {
    var vipResult = getVipGiftWrapDisplayTotal(window.giftWrapVipConfig || {}, giftArrayOne);
    var totalPriceWithSign = vipResult.formattedWithSign;
  } else {
    var totalPrice = 0;
    for (var i = 0; i < giftArrayOne.length; i++) {
      totalPrice += parseFloat(giftArrayOne[i].giftProductPrice * giftArrayOne[i].giftproductQuantity);
    }
    var currSym = document.body.getAttribute('data-currency-symbol') || '$';
    var totalPriceWithSign = totalPrice > 0
      ? currSym + Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(totalPrice / 100)
      : '';
  }

  if (giftArrayOne.length > 0 && totalPriceWithSign) {
    var totalElement = document.querySelector('.js-cart_gifttotal');
    if (totalElement) {
      totalElement.textContent = totalPriceWithSign;
    } else {
      var ulElement = document.querySelector('ul.cart__summary-details');
      if (ulElement) {
        var liElement = document.createElement('li');
        liElement.classList.add('cart-summary__list');
        liElement.innerHTML =
          '<span class="cart-summary__key">Gift Wrapping</span>' +
          '<span class="cart-summary__value js-cart_gifttotal gift-price">' + totalPriceWithSign + '</span>';
        var secondLiElement = ulElement.children[1];
        ulElement.insertBefore(liElement, secondLiElement);
      }
    }
  }
  syncOrderSummaryWithCart(cartData);
}

function UpdateSubtotalExcludingGW(cartData) {
  syncOrderSummaryWithCart(cartData);
}

function updateCartTotal(cartData) {
  syncOrderSummaryWithCart(cartData);
}
      

  // $("body").on("change", "[data-cart-quantity-bundle-input]", function () {
  //   const cartItem = {
  //     lineID: $(this).data("cart-item-indices"),
  //     variantID: $(this).parents("[data-cart-item]").data("variant-id"),
  //     quantity: $(this).val(),
  //     parentCartForm: $(this).parents("[data-cart-form]"),
  //     totalDiscount: $(this).parents("[data-cart-form]").data("total-discount"),
  //     $element: $(this).parents("[data-cart-item]"),
  //   };
    
  //   // Disable button after click to prevent multiple clicks
  //   $(this)
  //     .parents(".product-quantity-box")
  //     .find(".js-change-quantity")
  //     .addClass("is-disabled");
       
  //       updateCartItemMultipleQuantity(cartItem);
 
  // });

  $("body").on("click", "[data-remove-item]", function (e) {
    e.preventDefault();
    const cartItem = {
      lineID: $(this).parents("[data-cart-item]").data("line-id"),
      variantID: $(this).parents("[data-cart-item]").data("variant-id"),
      quantity: 0,
      parentCartForm: $(this).parents("[data-cart-form]"),
      totalDiscount: $(this).parents("[data-cart-form]").data("total-discount"),
      $element: $(this).parents("[data-cart-item]"),
    };

    // Check if this is an embroidery main product
    const embroiderySyncCode = $(this).closest('[data-cart-item]').find('[data-embroidery-main]').attr('data-embroidery-main');
    
    // Handle removal of embroidery products
    if (embroiderySyncCode) {
      (async () => {
        try {
          // Get the current cart data
          const response = await fetch('/cart.js');
          const cart = await response.json();
          
          // Convert cart.items to array if it's not already
          const itemsArray = Array.isArray(cart.items) ? cart.items : Object.values(cart.items || {});
          
          // Find all related items with the same sync code
          const relatedItems = itemsArray.filter(item => 
            item && 
            item.properties && 
            item.properties._sync === embroiderySyncCode
          );

          console.log('relatedItems', relatedItems);
          
          // If we found related items, remove them all
          if (relatedItems.length > 0) {
            const updates = {};
            
            // Set quantity to 0 for all related items (including main product)
            relatedItems.forEach(item => {
              updates[item.key] = 0;
            });
            
            // Update cart to remove all items
            await fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ updates }),
            }).then(response => response.json())
              .then(data => {
                refreshCart(data);
                return;
              });
              
            // We've handled the removal through our custom logic, so we can return early
            return;
          }
        } catch (error) {
          console.error('Error removing embroidery products:', error);
          // Continue with normal flow if there's an error
        }
      })();
    } else {
      // Continue with existing gift wrapping logic if not already handled by embroidery logic
      if (!embroiderySyncCode) {
        const giftArray = JSON.parse(localStorage.getItem('giftArray')) || [];
        let giftIdToRemove = null;

        // Check if the cart item has an associated gift
        const updatedGiftArray = giftArray.filter(giftItem => {
          if (giftItem.productId === cartItem.variantID.toString()) {
            giftIdToRemove = giftItem.giftId;
            return false; // Remove this item from the giftArray
          }
          return true;
        });

        // Update the giftArray in localStorage
        localStorage.setItem('giftArray', JSON.stringify(updatedGiftArray));
        cartItem.$element.addClass("animated fadeOut");
        // Remove the gift item if a matching giftId was found
        if (giftIdToRemove) {
          updateCartItemQuantity(cartItem,giftIdToRemove);
        }
        else{
          updateCartItemQuantity(cartItem);
        }
      }
    }

    if (cartItem.parentCartForm.data("cart-form") === "cart-template") {
      cartItem.$element.find("input").val("0");
      cartItem.parentCartForm.submit();
    }

    if (cartItem.parentCartForm.data("cart-form") === "mini-cart") {
      cartItem.$element.find("input").val("0");
    }
  });


  // Rebuy Smart Cart (the live cart drawer) does not repaint after the theme's own cart
  // requests; asking it to re-read the cart does.
  function refreshSmartCart() {
    if (typeof window.Rebuy?.Cart?.fetchCart === 'function') window.Rebuy.Cart.fetchCart();
  }

  // Candle lid (PRO-15239): a candle added with a lid and that lid share a hidden `_lid_pair`
  // code (the lid also carries `_candle_sku`). An engraved lid's $5 Engraving Service line shares
  // it too (and carries `_parent_sku`). The pair is kept in step like embroidery:
  // - candle quantity changes -> the lid follows; lid quantity changes -> the candle follows
  // - candle removed -> its lid is removed; lid removed -> the candle stays
  // - the service line always follows its engraved lid, and goes when the lid goes
  // A plain lid bought on its own has no `_lid_pair` and is never touched; an engraved one (from the
  // lid's own PDP) only keeps its service line in step.
  // The last synced quantity per pair is kept in sessionStorage to tell which line changed;
  // when it is unknown, the candle wins.
  const CANDLE_LID_PAIRS_KEY = 'candleLidPairQuantities';

  // Matches /cart and market paths like /en-eu/cart or /en-gb/cart, not e.g. /collections/cart.
  // The <body> has no `cart` class on this theme's cart page, so it cannot be used here.
  function isCartPage() {
    return /^(\/[a-z]{2}(-[a-z]{2})?)?\/cart\/?$/.test(window.location.pathname);
  }

  function readCandleLidPairs() {
    try {
      return JSON.parse(sessionStorage.getItem(CANDLE_LID_PAIRS_KEY)) || {};
    } catch (error) {
      return {};
    }
  }

  function saveCandleLidPairs(pairs) {
    try {
      sessionStorage.setItem(CANDLE_LID_PAIRS_KEY, JSON.stringify(pairs));
    } catch (error) {
      // Storage unavailable (private mode): mirroring falls back to "candle wins"
    }
  }

  function cartItemsOf(cart) {
    return Array.isArray(cart?.items) ? cart.items : Object.values(cart?.items || {});
  }

  // Which part of a pair a cart line is: the lid (`_candle_sku`, or engraved when bought on its own
  // lid PDP), its engraving service (`_parent_sku`) or the candle
  function candleLidRole(item) {
    if (item.properties?._candle_sku || item.properties?._engraving_services === 'true') return 'lid';
    if (item.properties?._parent_sku) return 'service';
    return 'candle';
  }

  // Works out the quantity changes each pair needs. `current` is what to remember for next time.
  function candleLidPairChanges(items, previous) {
    const current = {};
    const updates = {};
    const pairs = new Map();

    for (const item of items) {
      const pairCode = item.properties?._lid_pair;
      if (!pairCode) continue;
      if (!pairs.has(pairCode)) pairs.set(pairCode, { candle: null, lid: null, service: null });
      pairs.get(pairCode)[candleLidRole(item)] = item;
    }

    for (const [pairCode, { candle, lid, service }] of pairs) {
      if (!lid) {
        // lid removed on purpose: the candle stays, its engraving service goes
        if (service) updates[service.key] = 0;
        continue;
      }

      // Engraved lid bought on its own lid PDP: no candle, the service just follows the lid
      if (!lid.properties._candle_sku) {
        if (service && service.quantity !== lid.quantity) updates[service.key] = lid.quantity;
        continue;
      }

      if (!candle) {
        updates[lid.key] = 0;
        if (service) updates[service.key] = 0;
        continue;
      }

      const lidChanged = lid.quantity !== candle.quantity && previous[pairCode] === candle.quantity;
      const quantity = lidChanged ? lid.quantity : candle.quantity;
      if (candle.quantity !== quantity) updates[candle.key] = quantity;
      if (lid.quantity !== quantity) updates[lid.key] = quantity;

      if (service) {
        const serviceQuantity = lid.properties._engraving_services === 'true' ? quantity : 0;
        if (service.quantity !== serviceQuantity) updates[service.key] = serviceQuantity;
      }
      current[pairCode] = quantity;
    }

    return { updates, current };
  }

  // Runs one sync at a time: two overlapping runs would both act on the same stale line keys.
  let candleLidSyncQueue = Promise.resolve();

  // Returns the updated cart, or null when nothing had to change.
  async function syncCandleLids(cart) {
    const previousRun = candleLidSyncQueue;
    let releaseQueue;
    candleLidSyncQueue = new Promise((resolve) => {
      releaseQueue = resolve;
    });

    await previousRun;
    try {
      return await runCandleLidSync(cart);
    } finally {
      releaseQueue();
    }
  }

  async function runCandleLidSync(cart) {
    const previous = readCandleLidPairs();
    const firstLook = candleLidPairChanges(cartItemsOf(cart), previous);

    if (Object.keys(firstLook.updates).length === 0) {
      saveCandleLidPairs(firstLook.current);
      return null;
    }

    try {
      // Act on the live cart, not the one passed in, so every line key still exists
      const liveCart = await (await fetch('/cart.js')).json();
      const { updates, current } = candleLidPairChanges(cartItemsOf(liveCart), previous);
      saveCandleLidPairs(current);
      let updatedCart = null;

      // /cart/change.js by line key: a key that no longer exists fails (400) instead of
      // /cart/update.js's fallback to every line of that variant, which would hit standalone lids
      for (const [key, quantity] of Object.entries(updates)) {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity }),
        });
        if (response.ok) updatedCart = await response.json();
      }

      if (!updatedCart) return null;
      // The cart page renders server-side, so show the corrected quantities by reloading it
      if (isCartPage()) window.location.reload();
      refreshSmartCart();
      return updatedCart;
    } catch (error) {
      console.error('[Candle lid]', error);
      return null;
    }
  }

  // Cart properties can be set by anyone through the cart API, so escape them in markup
  function escapeCandleLidHTML(value) {
    return String(value || '').replace(/[&<>"']/g, (char) => `&#${char.charCodeAt(0)};`);
  }

  // Unit price of an embroidered item's service line(s) (same `_sync`), 0 for anything else.
  // Matches the cart row Liquid in snippets/cart-template-row-block.liquid.
  function embroideryServicePrice(item, cart) {
    if (item.properties?._embroidery_services !== 'true' || !item.properties._sync) return 0;

    let price = 0;
    for (const line of cartItemsOf(cart)) {
      if (line.key !== item.key && line.properties?._sync === item.properties._sync) {
        price += line.price;
      }
    }
    return price;
  }

  // Price of an engraved lid's Engraving Service line(s), 0 for anything else. Added to the lid's
  // displayed price, the way embroidery adds its service price to the main item.
  function candleLidServicePrice(item, cart) {
    if (item.properties?._engraving_services !== 'true' || !item.properties._lid_pair) return 0;

    let price = 0;
    for (const line of cartItemsOf(cart)) {
      if (line.properties?._lid_pair === item.properties._lid_pair && candleLidRole(line) === 'service') {
        price += line.price;
      }
    }
    return price;
  }

  // Engraving rows for a lid line in the theme mini-cart (empty for anything else). The first row
  // reuses embroidery's "• Includes embroidery · Edit" classes so both look the same.
  function candleLidEngravingHTML(item) {
    if (item.properties?._engraving_services !== 'true') return '';

    const escapeHTML = escapeCandleLidHTML;
    const editLink = item.properties._lid_pair
      ? `<span class="minicart__value-embroidery"><button type="button" class="candle-lid-edit-link" data-lid-pair="${escapeHTML(item.properties._lid_pair)}" aria-label="Edit engraving">Edit</button></span>`
      : '';
    return `
      <div class="minicart__item-row--attr minicart__item-row--embroidery minicart__item-row--engraving-note">
        <span class="minicart__label-embroidery"><span class="minicart__bullet">•</span> Includes engraving</span>
        ${editLink}
      </div>
      <div class="minicart__item-row minicart__item-row--attr minicart__item-row--engraving">
        <span class="minicart__label">Engraving:</span>
        <span class="minicart__value">${escapeHTML(item.properties.Engraving)}</span>
      </div>
      <div class="minicart__item-row minicart__item-row--attr minicart__item-row--engraving-font">
        <span class="minicart__label">Font:</span>
        <span class="minicart__value">${escapeHTML(item.properties['Engraving Font'])}</span>
      </div>`;
  }

  // Engraving "Edit" link, like embroidery's: in the theme mini-cart (above) and in Rebuy Smart
  // Cart (its template in the Rebuy admin uses the same class and data-lid-pair). Opens the
  // candle's engraving modal with the lid's text and font; saving updates that lid line
  // (assets/component-candle-lid.js). The candle's page is looked up from the cart by pair code.
  document.addEventListener('click', async (event) => {
    const editLink = event.target.closest('.candle-lid-edit-link');
    if (!editLink) return;
    event.preventDefault();

    const pair = editLink.dataset.lidPair;
    if (!pair) return;

    try {
      const items = cartItemsOf(await (await fetch('/cart.js')).json());
      const lid = items.find((item) => item.properties?._lid_pair === pair && candleLidRole(item) === 'lid');
      // The modal lives on the candle's PDP, or on the lid's own PDP for a lid bought on its own
      const candle =
        items.find((item) => item.properties?._lid_pair === pair && candleLidRole(item) === 'candle') ||
        (lid && !lid.properties._candle_sku ? lid : null);
      if (!lid || !candle) {
        // The drawer is out of date (e.g. the lid was removed in another tab): show the real cart
        refreshSmartCart();
        return;
      }

      // item.url has no market prefix (/en-eu/...); routes.root keeps the shopper in their market
      const root = (window.Shopify?.routes?.root || '/').replace(/\/$/, '');
      const candleUrl = new URL(`${root}${candle.url}`, window.location.origin);
      candleUrl.searchParams.set('engraving', lid.properties.Engraving || '');
      candleUrl.searchParams.set('engraving_font', lid.properties['Engraving Font'] || '');
      candleUrl.searchParams.set('lid_pair', pair);
      candleUrl.searchParams.set('editmode', 'true');

      document.documentElement.classList.remove('cart-active');
      if (window.Rebuy?.SmartCart?.status === 'ready' && typeof window.Rebuy.SmartCart.hide === 'function') {
        window.Rebuy.SmartCart.hide();
      }

      // Already on the candle's page: open its modal here instead of reloading
      const lidOption = document.querySelector('candle-lid-option');
      if (window.location.pathname !== candleUrl.pathname || typeof lidOption?.openEdit !== 'function') {
        window.location.href = candleUrl.toString();
        return;
      }
      window.history.replaceState({}, '', candleUrl);
      lidOption.openEditFromUrl();
    } catch (error) {
      console.error('[Candle lid]', error);
    }
  });

  // Rebuy Smart Cart (the live cart drawer) changes lines itself and never calls refreshCart.
  // Its line-item events fire as the change lands, so re-check the live cart shortly after.
  let candleLidCheckTimer = null;
  function scheduleCandleLidSync() {
    clearTimeout(candleLidCheckTimer);
    candleLidCheckTimer = setTimeout(async () => {
      try {
        const cart = await (await fetch('/cart.js')).json();
        await syncCandleLids(cart);
      } catch (error) {
        console.error('[Candle lid]', error);
      }
    }, 600);
  }

  for (const eventName of [
    'rebuy:smartcart.line-item-removed',
    'rebuy:smartcart.line-item-decrease',
    'rebuy:smartcart.line-item-increase',
  ]) {
    document.addEventListener(eventName, scheduleCandleLidSync);
  }

  // The cart page renders server-side, so check once on load (syncCandleLids reloads it on a change)
  if (isCartPage()) scheduleCandleLidSync();

  // Candle lid (PRO-15239): the lid option (snippets/component-candle-lid.liquid) lives in the
  // same PDP section as the add-to-cart form. Returns its cart lines (the lid, plus the engraving
  // service when engraved), or [] when no lid is selected.
  function getCandleLidItems(form, quantity, candleSku) {
    const section = form.closest('.shopify-section');
    const lidOption = section ? section.querySelector('candle-lid-option') : null;
    if (!lidOption || typeof lidOption.getCartItems !== 'function') return [];
    return lidOption.getCartItems(quantity, candleSku);
  }

  // Adds the selected lid as its own line, after the candle. It is a separate request so a lid
  // that cannot be added (e.g. out of stock) never blocks the candle; the shopper sees why instead.
  async function addCandleLid(form, quantity, candleSku, addUrl) {
    const lidItems = getCandleLidItems(form, quantity, candleSku);
    if (lidItems.length === 0) return;

    let reason = '';
    try {
      const response = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: lidItems }),
      });
      if (response.ok) {
        form.closest('.shopify-section')?.querySelector('candle-lid-option')?.onLidAdded?.();
        refreshSmartCart();
        return;
      }
      const error = await response.json().catch(() => ({}));
      reason = error.description || '';
    } catch (error) {
      console.error('[Candle lid]', error);
    }

    const warning = document.createElement('p');
    warning.className = 'warning animated bounceIn';
    warning.setAttribute('role', 'alert');

    for (const oldWarning of form.parentElement.querySelectorAll('.warning')) {
      oldWarning.remove();
    }
    form.after(warning);
    // Text goes in after the empty alert is in the page, so screen readers announce it
    requestAnimationFrame(() => {
      warning.textContent = `Your candle was added, but the candle lid could not be added. ${reason}`.trim();
    });
  }

  // Generate a random sync code for linking products
  function generateSyncCode(length) {
    const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  }

  if (window.PXUTheme.theme_settings.cart_action === "ajax") {
    $(document).on("click", ".ajax-submit", async function (e) {
      e.preventDefault();
      
      const $addToCartForm = $(this).closest("form");
      const $addToCartBtn = $addToCartForm.find(".add_to_cart");
      let isRiseProduct = false

      if ($(this).hasClass('Rise-add-to-cart-button')) {
        isRiseProduct = true
      }

      // Refresh page on quick shop add to cart if on cart page
      if ($("body").hasClass("cart")) {
        $addToCartForm.submit();
        return false; // Prevent AJAX add to cart from executing
      }

      // Check if this product has a free bag
      const freeBagVariantId = $addToCartBtn.data('free-bag-id');
      
      // Get the current URL
      var currentUrl = window.location.href;
      // Extract the protocol, domain, and market URL parts from currentUrl
      var protocol = currentUrl.split('/')[0];
      var domain = currentUrl.split('/')[2];
      var marketUrl = currentUrl.split('/')[3];
      // Construct the base URL using the extracted protocol
      var baseUrl = `${protocol}//${domain}`;
      
      // Check if the current URL contains "-eu" or "-gb"
      if (currentUrl.includes("-eu") || currentUrl.includes("-gb")) {
          baseUrl += `/${marketUrl}`;
      }
      
      // Construct the final URL for the AJAX request
      var finalUrl = baseUrl + "/cart/add.js";

      // If we have a free bag, handle both products together
      if (freeBagVariantId) {
        try {
          // Disable add to cart button
          // $addToCartBtn.attr("disabled", "disabled").addClass("disabled");
          // $addToCartBtn
          //   .find("span")
          //   .removeClass("fadeInDown")
          //   .addClass("animated zoomOut");
            
          // Generate random sync code for linking main product and free bag
          const syncCode = generateSyncCode(6);
          
          // Get main product information
          const quantityInput = $addToCartForm.find('input[name="quantity"]');
          const quantity = quantityInput.length > 0 ? parseInt(quantityInput.val()) : 1; // Default to 1 if quantity input not found
          const mainProductVariantId = $addToCartForm.find('select[name="id"], input[name="id"]').val();
          const mainProductSku = $addToCartBtn.attr('data-main-product-sku') || '';
          const freeBagSku = $addToCartBtn.attr('data-free-bag-sku') || '';
          
          // Create main product properties
          const currentProperties = {};
          $addToCartForm.find('input[name^="properties"]').each(function() {
            const key = $(this).attr('name').replace('properties[', '').replace(']', '');
            const value = $(this).val();
            if (value) currentProperties[key] = value;
          });
          
          // Add sync properties to main product
          const mainProductProperties = {
            ...currentProperties,
            '_sync': syncCode,
            '_free_bag': freeBagSku
          };
          
          // Add free bag properties (this will go to the free bag product)
          const freeBagProperties = {
            '_sync': syncCode,
            '_free_bag_for_sku': mainProductSku
          };
          
          // Add both products to cart in one request
          const cartData = {
            items: [
              {
                id: mainProductVariantId,
                quantity: quantity,
                properties: mainProductProperties
              },
              {
                id: freeBagVariantId,
                quantity: quantity,
                properties: freeBagProperties
              }
            ]
          };
          
          // Add both products together
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(cartData)
          });
          
          const addResult = await response.json();

          // Candle lid (PRO-15239): only once the candle is in. The SKU comes from the response,
          // since data-main-product-sku is the variant selected when the page loaded.
          if (response.ok) {
            const addedCandle = (addResult.items || []).find((item) => String(item.variant_id) === String(mainProductVariantId));
            await addCandleLid($addToCartForm[0], quantity, addedCandle ? addedCandle.sku : mainProductSku, finalUrl);
          }
          
          // Reset button state
          $addToCartBtn.removeClass("disabled");
          $addToCartBtn
            .find("span")
            .removeClass("fadeInDown")
            .addClass("fadeInDown");
          
          // Refresh cart to show updated items with properties
          $.ajax({
            url: "/cart.js",
            dataType: "json",
            cache: false,
            success: function(updatedCart) {
              refreshCart(updatedCart);
              $("html").addClass("cart-active");
              
              //scroll the cart to the top
              document.querySelector('.cart_content').scrollTo(0,0);
            }
          });
          
        } catch (error) {
          console.error("Error adding product with free bag:", error);
          // Reset button state on error
          $addToCartBtn.removeAttr("disabled").removeClass("disabled");
          $addToCartBtn
            .find("span")
            .text(window.PXUTheme.translation.add_to_cart)
            .removeClass("zoomOut")
            .addClass("zoomIn");
            
          // Show error message
          $(".warning").remove();
          const warning = `<p class="warning animated bounceIn">There was an error adding this product to your cart. Please try again.</p>`;
          $addToCartForm.after(warning);
        }
        
        // Skip the original AJAX call
        return false;
      }
      
      // Original add to cart flow for products without free bag
      await $.ajax({
        url: finalUrl,
        dataType: "json",
        cache: false,
        type: "post",
        data: $addToCartForm.serialize(),
        beforeSend() {
          $addToCartBtn.attr("disabled", "disabled").addClass("disabled");
          $addToCartBtn
            .find("span")
            .removeClass("fadeInDown")
            .addClass("animated zoomOut");
        },
        success: async (cart) => {
          // Handle subscription products (selling plan allocation)
          if (cart.selling_plan_allocation) {
            discount = cart.selling_plan_allocation.compare_at_price - cart.selling_plan_allocation.per_delivery_price;
            percentage = (discount / cart.selling_plan_allocation.compare_at_price) * 100;
            discount = ((discount / 100) * cart.quantity).toFixed(2);
            let data = {
              line: 1,
              quantity: cart.quantity,
              properties: {
                'Discount': `${percentage}% off ($${discount})`,
                // Candle lid (PRO-15239): this call replaces the line's properties; keep its lid link
                ...(cart.properties?._lid_pair ? { _lid_pair: cart.properties._lid_pair } : {}),
              }
            }
            await $.ajax({
              url: "/cart/change.js",
              dataType: "json",
              cache: false,
              type: "post",
              data: data,
              success(data) {
                // console.log('Subscription product properties updated.', cart);
              }
            });
          }

          // Candle lid (PRO-15239): added after the candle and after the subscription update
          // above, which edits cart line 1 and must still find the candle there.
          const lidQuantity = parseInt($addToCartForm.find('input[name="quantity"]').val(), 10) || 1;
          await addCandleLid($addToCartForm[0], lidQuantity, cart.sku, finalUrl);
          
          //scroll the cart to the top
          const cartContent = document.querySelector('.cart_content');
          if (cartContent) {
            cartContent.scrollTo(0,0);
          }
          if (typeof $ !== 'undefined' && $("body").hasClass("fancybox-active") && $.fancybox) {
            $.fancybox.close();
          }

          if ($("#header").is(":visible")) {
            $("#header .cart-container").addClass("active_link");
          } else if ($(".sticky_nav--stick").length) {
            $(".sticky_nav .cart-container").addClass("active_link");
          } else {
            $(".top-bar .cart-container").addClass("active_link");
          }

          // Safety net only: opening the drawer already hands focus to it from cart-drawer-js, and
          // that helper leaves focus alone when it is inside the drawer, so this is usually a no-op.
          setTimeout(function() {
            if (typeof window.focusCartDrawer === 'function') {
              window.focusCartDrawer({ delay: 0 });
            }
          }, 300); 

         


          // block scrolling on mobile
          if (window.PXUTheme.media_queries.medium.matches) {
            const $cartContainer = $(this).parent();
            //if ($cartContainer.hasClass("active_link")) {
              //$("body").addClass("blocked-scroll");
            //} else {
              //$("body").addClass("blocked-scroll");
           // }

            // Scroll to the top of the page unless the header is fixed
            const header = document.getElementById("header");
            if (header.classList.contains("mobile_nav-fixed--false")) {
              window.scroll({ top: 0, left: 0, behavior: "smooth" });
            }
          }

          $addToCartBtn.find(".checkmark").addClass("checkmark-active");

          // window.setTimeout(() => {
            $addToCartBtn.removeAttr("disabled").removeClass("disabled");
            $addToCartBtn.find(".checkmark").removeClass("checkmark-active");
            $addToCartBtn
              .find("span")
              .removeClass("zoomOut")
              .addClass("fadeInDown");
          // }, 1000);

          await $.ajax({
            url: "/cart.js",
            dataType: "json",
            cache: false,
            success(cart) {

              if(isRiseProduct){
                 
                // $("html").addClass("cart-active");
                // const RisePopupWrapperElement = document.querySelector('.Rise-popup-backdrop');
                // const RisePopupWrapperElementWrapper = document.querySelector('.Rise-popup');
                
                // if (RisePopupWrapperElement) {
                //     RisePopupWrapperElement.classList.remove('show');
                // }
                // if(RisePopupWrapperElementWrapper){
                //     RisePopupWrapperElementWrapper.classList.remove('open');
                // }
                
                const RisePopupWrapperElement = document.querySelector('.Rise-popup-backdrop');
                const intervalTimeForCheckClass = 100;
                if (RisePopupWrapperElement) {
                  const intervalForCheckClass = setInterval(() => {
                    if (!RisePopupWrapperElement.classList.contains('show')) {
                        refreshCart(cart); 
                        $("html").addClass("cart-active");
                          clearInterval(intervalForCheckClass);
                      }
                  }, intervalTimeForCheckClass);
                }
              } else{
                refreshCart(cart);
                $("html").addClass("cart-active");
            
              }
              
            },
          });

          // --- START: Add free bag if button has data attribute ---
          const freeBagVariantId = $addToCartBtn.data('free-bag-id');
          if (freeBagVariantId) {
            try {
              // Generate random sync code for linking main product and free bag
              const syncCode = generateSyncCode(6);
              
              // Get main product information
              const quantityInput = $addToCartForm.find('input[name="quantity"]');
              const quantity = quantityInput.length > 0 ? parseInt(quantityInput.val()) : 1; // Default to 1 if quantity input not found
              const mainProductVariantId = $addToCartForm.find('select[name="id"], input[name="id"]').val();
              const mainProductSku = $addToCartBtn.attr('data-main-product-sku') || '';
              const freeBagSku = $addToCartBtn.attr('data-free-bag-sku') || '';
              
              // Create main product properties
              const currentProperties = {};
              $addToCartForm.find('input[name^="properties"]').each(function() {
                const key = $(this).attr('name').replace('properties[', '').replace(']', '');
                const value = $(this).val();
                if (value) currentProperties[key] = value;
              });
              
              // Add sync properties to main product
              const mainProductProperties = {
                ...currentProperties,
                '_sync': syncCode,
                '_free_bag': freeBagSku
              };
              
              // Add free bag properties (this will go to the free bag product)
              const freeBagProperties = {
                '_sync': syncCode,
                '_free_bag_for_sku': mainProductSku
              };
              
              // Add both products to cart in one request
              const cartData = {
                items: [
                  {
                    id: mainProductVariantId,
                    quantity: quantity,
                    properties: mainProductProperties
                  },
                  {
                    id: freeBagVariantId,
                    quantity: quantity,
                    properties: freeBagProperties
                  }
                ]
              };
              
              // Add both products together
              const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(cartData)
              });
              
              const addResult = await response.json();
              
              // Refresh cart to show updated items with properties
              $.ajax({
                url: "/cart.js",
                dataType: "json",
                cache: false,
                success: function(updatedCart) {
                  refreshCart(updatedCart);
                  $("html").addClass("cart-active");
                }
              });
              
            } catch (error) {
              console.error("Error adding free bag:", error);
            }
            
            // Skip the rest of the success function, as we've already added both products
            return;
          }
          // --- END: Add free bag if button has data attribute ---

          //scroll the cart to the top
          const cartContenta = document.querySelector('.cart_content');
            if (cartContenta && typeof cartContenta.scrollTo === 'function') {
              cartContenta.scrollTo(0,0);
            }
        },
        error(XMLHttpRequest) {
          let response = eval(`(${XMLHttpRequest.responseText})`);
          response = response.description;
          $(".warning").remove();

          const warning = `<p class="warning animated bounceIn">${response.replace(
            "All 1 ",
            "All "
          )}</p>`;
          $addToCartForm.after(warning);
          $addToCartBtn.removeAttr("disabled").removeClass("disabled");
          $addToCartBtn
            .find("span")
            .text(window.PXUTheme.translation.add_to_cart)
            .removeClass("zoomOut")
            .addClass("zoomIn");
        },
      });

      return false;
    });
  }

  window.productPage.productSwatches();

  // $.ajax({
  //   url: "/cart.json",
  //   dataType: "json",
  //   cache: false,
  //   type: "get",
  //   success(data) {
  //     window.refreshCart(data);
  //   },
  // });
});

/*= ===========================================================================
  Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
============================================================================== */
window.Shopify.updateOptionsInSelector = function (selectorIndex, parent) {
  switch (selectorIndex) {
    case 0:
      var key = "root";
      break;
    case 1:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      break;
    case 2:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      key += ` / ${$(`${parent} .single-option-selector:eq(1)`).val()}`;
  }

  const availableOptions = Shopify.optionsMap[key];
  $(
    `${parent} .swatch[data-option-index="${selectorIndex}"] .swatch-element`
  ).each(function () {
    if ($.inArray($(this).attr("data-value"), availableOptions) !== -1) {
      $(this)
        .removeClass("soldout")
        .find(":radio")
        .removeAttr("disabled", "disabled")
        .removeAttr("checked");
    } else {
      $(this)
        .addClass("soldout")
        .find(":radio")
        .removeAttr("checked")
        .attr("disabled", "disabled");
    }
  });
};

window.Shopify.linkOptionSelectors = function (product, parent) {
  // Building our mapping object.
  window.Shopify.optionsMap = {};
  for (let i = 0; i < product.variants.length; i++) {
    const variant = product.variants[i];
    if (variant.available) {
      // Gathering values for the 1st drop-down.
      window.Shopify.optionsMap.root = window.Shopify.optionsMap.root || [];
      window.Shopify.optionsMap.root.push(variant.option1);
      window.Shopify.optionsMap.root = window.Shopify.uniq(
        window.Shopify.optionsMap.root
      );
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        const key = variant.option1;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option2);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(
          window.Shopify.optionsMap[key]
        );
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        const key = `${variant.option1} / ${variant.option2}`;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option3);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(
          window.Shopify.optionsMap[key]
        );
      }
    }
  }
  // Update options right away.
  window.Shopify.updateOptionsInSelector(0, parent);
  if (product.options.length > 1)
    window.Shopify.updateOptionsInSelector(1, parent);
  if (product.options.length === 3)
    window.Shopify.updateOptionsInSelector(2, parent);
  // When there is an update in the first dropdown.
  $(`${parent} .single-option-selector:eq(0)`).change(() => {
    window.Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3)
      window.Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
  // When there is an update in the second dropdown.
  $(`${parent} .single-option-selector:eq(1)`).change(() => {
    if (product.options.length === 3)
      window.Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
};

// Used for cart functionality
window.htmlEncode = function htmlEncode(value) {
  if (value) {
    return $("<div/>").text(value).html();
  }
  return "";
};

// Check if device is touch-enabled
window.is_touch_device = function is_touch_device() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
};

// Differentiate between mobile and touch screen laptops
window.touch_device = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
  navigator.userAgent
);

/* option_selection.js */
function floatToString(t, e) {
  const o = t.toFixed(e).toString();
  return o.match(/^\.\d+/) ? `0${o}` : o;
}
if (typeof window.Shopify === "undefined") window.Shopify = {};
(window.Shopify.each = function (t, e) {
  for (let o = 0; o < t.length; o++) e(t[o], o);
}),
  (window.Shopify.map = function (t, e) {
    for (var o = [], i = 0; i < t.length; i++) o.push(e(t[i], i));
    return o;
  }),
  (window.Shopify.arrayIncludes = function (t, e) {
    for (let o = 0; o < t.length; o++) if (t[o] == e) return !0;
    return !1;
  }),
  (window.Shopify.uniq = function (t) {
    for (var e = [], o = 0; o < t.length; o++)
      window.Shopify.arrayIncludes(e, t[o]) || e.push(t[o]);
    return e;
  }),
  (window.Shopify.isDefined = function (t) {
    return typeof t === "undefined" ? !1 : !0;
  }),
  (window.Shopify.getClass = function (t) {
    return Object.prototype.toString.call(t).slice(8, -1);
  }),
  (window.Shopify.extend = function (t, e) {
    function o() {}
    (o.prototype = e.prototype),
      (t.prototype = new o()),
      (t.prototype.constructor = t),
      (t.baseConstructor = e),
      (t.superClass = e.prototype);
  }),
  (window.Shopify.locationSearch = function () {
    return window.location.search;
  }),
  (window.Shopify.locationHash = function () {
    return window.location.hash;
  }),
  (window.Shopify.replaceState = function (t) {
    window.history.replaceState({}, document.title, t);
  }),
  (window.Shopify.urlParam = function (t) {
    const e = RegExp(`[?&]${t}=([^&#]*)`).exec(window.Shopify.locationSearch());
    return e && decodeURIComponent(e[1].replace(/\+/g, " "));
  }),
  (window.Shopify.newState = function (t, e) {
    let o;
    return (
      (o = window.Shopify.urlParam(t)
        ? window.Shopify.locationSearch().replace(
            RegExp(`(${t}=)[^&#]+`),
            `$1${e}`
          )
        : window.Shopify.locationSearch() === ""
        ? `?${t}=${e}`
        : `${window.Shopify.locationSearch()}&${t}=${e}`),
      o + window.Shopify.locationHash()
    );
  }),
  (window.Shopify.setParam = function (t, e) {
    window.Shopify.replaceState(window.Shopify.newState(t, e));
  }),
  (window.Shopify.Product = function (t) {
    window.Shopify.isDefined(t) && this.update(t);
  }),
  (window.Shopify.Product.prototype.update = function (t) {
    for (property in t) this[property] = t[property];
  }),
  (window.Shopify.Product.prototype.optionNames = function () {
    return window.Shopify.getClass(this.options) == "Array" ? this.options : [];
  }),
  (window.Shopify.Product.prototype.optionValues = function (t) {
    if (!window.Shopify.isDefined(this.variants)) return null;
    const e = window.Shopify.map(this.variants, (e) => {
      const o = `option${t + 1}`;
      return void 0 == e[o] ? null : e[o];
    });
    return e[0] == null ? null : window.Shopify.uniq(e);
  }),
  (window.Shopify.Product.prototype.getVariant = function (t) {
    let e = null;
    return t.length != this.options.length
      ? e
      : (window.Shopify.each(this.variants, (o) => {
          for (var i = !0, r = 0; r < t.length; r++) {
            const n = `option${r + 1}`;
            o[n] != t[r] && (i = !1);
          }
          return i == 1 ? void (e = o) : void 0;
        }),
        e);
  }),
  (window.Shopify.Product.prototype.getVariantById = function (t) {
    for (let e = 0; e < this.variants.length; e++) {
      const o = this.variants[e];
      if (t == o.id) return o;
    }
    return null;
  }),
  
  
  (window.Shopify.money_format = "$"),
  
  (window.Shopify.formatMoney = function (t, e) {
    function o(t, e) {
      return typeof t === "undefined" ? e : t;
    }
    function i(t, e, i, r) {
      if (
        ((e = o(e, 2)), (i = o(i, ",")), (r = o(r, ".")), isNaN(t) || t == null)
      )
        return 0;
      t = (t / 100).toFixed(e);
      const n = t.split(".");
      const a = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${i}`);
      const s = n[1] ? r + n[1] : "";
      return a + s;
    }
    typeof t === "string" && (t = t.replace(".", ""));
    let r = "";
    const n = /\{\{\s*(\w+)\s*\}\}/;
    const a = e || this.money_format;
    switch (a.match(n)[1]) {
      case "amount":
        r = i(t, 2);
        break;
      case "amount_no_decimals":
        r = i(t, 0);
        break;
      case "amount_with_comma_separator":
        r = i(t, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        r = i(t, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        r = i(t, 0, ".", ",");
    }
    return a.replace(n, r);
  }),
  (window.Shopify.OptionSelectors = function (t, e) {
    return (
      (this.selectorDivClass = "selector-wrapper"),
      (this.selectorClass = "single-option-selector"),
      (this.variantIdFieldIdSuffix = "-variant-id"),
      (this.variantIdField = null),
      (this.historyState = null),
      (this.selectors = []),
      (this.domIdPrefix = t),
      (this.product = new window.Shopify.Product(e.product)),
      (this.onVariantSelected = window.Shopify.isDefined(e.onVariantSelected)
        ? e.onVariantSelected
        : function () {}),
      this.replaceSelector(t),
      this.initDropdown(),
      e.enableHistoryState &&
        (this.historyState = new window.Shopify.OptionSelectors.HistoryState(
          this
        )),
      !0
    );
  }),
  (window.Shopify.OptionSelectors.prototype.initDropdown = function () {
    const t = { initialLoad: !0 };
    const e = this.selectVariantFromDropdown(t);
    if (!e) {
      const o = this;
      setTimeout(() => {
        o.selectVariantFromParams(t) ||
          o.fireOnChangeForFirstDropdown.call(o, t);
      });
    }
  }),
  (window.Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown =
    function (t) {
      this.selectors[0].element.onchange(t);
    }),
  (window.Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown =
    function (t) {
      const e = this.selectVariantFromParams(t);
      e || this.selectVariantFromDropdown(t);
    }),
  (window.Shopify.OptionSelectors.prototype.replaceSelector = function (t) {
    const e = document.getElementById(t);
    const o = e.parentNode;
    window.Shopify.each(this.buildSelectors(), (t) => {
      o.insertBefore(t, e);
    }),
      (e.style.display = "none"),
      (this.variantIdField = e);
  }),
  (window.Shopify.OptionSelectors.prototype.selectVariantFromDropdown =
    function (t) {
      let e = document
        .getElementById(this.domIdPrefix)
        .querySelector("[selected]");
      if (
        (e ||
          (e = document
            .getElementById(this.domIdPrefix)
            .querySelector('[selected="selected"]')),
        !e)
      )
        return !1;
      const o = e.value;
      return this.selectVariant(o, t);
    }),
  (window.Shopify.OptionSelectors.prototype.selectVariantFromParams = function (
    t
  ) {
    const e = window.Shopify.urlParam("variant");
    return this.selectVariant(e, t);
  }),
  (window.Shopify.OptionSelectors.prototype.selectVariant = function (t, e) {
    const o = this.product.getVariantById(t);
    if (o == null) return !1;
    for (let i = 0; i < this.selectors.length; i++) {
      const r = this.selectors[i].element;
      const n = r.getAttribute("data-option");
      const a = o[n];
      a != null && this.optionExistInSelect(r, a) && (r.value = a);
    }
    return (
      typeof jQuery !== "undefined"
        ? jQuery(this.selectors[0].element).trigger("change", e)
        : this.selectors[0].element.onchange(e),
      !0
    );
  }),
  (window.Shopify.OptionSelectors.prototype.optionExistInSelect = function (
    t,
    e
  ) {
    for (let o = 0; o < t.options.length; o++)
      if (t.options[o].value == e) return !0;
  }),
  (window.Shopify.OptionSelectors.prototype.insertSelectors = function (t, e) {
    window.Shopify.isDefined(e) && this.setMessageElement(e),
      (this.domIdPrefix = `product-${this.product.id}-variant-selector`);
    const o = document.getElementById(t);
    window.Shopify.each(this.buildSelectors(), (t) => {
      o.appendChild(t);
    });
  }),
  (window.Shopify.OptionSelectors.prototype.buildSelectors = function () {
    for (let t = 0; t < this.product.optionNames().length; t++) {
      const e = new window.Shopify.SingleOptionSelector(
        this,
        t,
        this.product.optionNames()[t],
        this.product.optionValues(t)
      );
      (e.element.disabled = !1), this.selectors.push(e);
    }
    const o = this.selectorDivClass;
    const i = this.product.optionNames();
    const r = window.Shopify.map(this.selectors, (t) => {
      const e = document.createElement("div");
      if ((e.setAttribute("class", o), i.length > 1)) {
        const r = document.createElement("label");
        (r.htmlFor = t.element.id), (r.innerHTML = t.name), e.appendChild(r);
      }
      return e.appendChild(t.element), e;
    });
    return r;
  }),
  (window.Shopify.OptionSelectors.prototype.selectedValues = function () {
    for (var t = [], e = 0; e < this.selectors.length; e++) {
      const o = this.selectors[e].element.value;
      t.push(o);
    }
    return t;
  }),
  (window.Shopify.OptionSelectors.prototype.updateSelectors = function (t, e) {
    const o = this.selectedValues();
    const i = this.product.getVariant(o);
    i
      ? ((this.variantIdField.disabled = !1),
        (this.variantIdField.value = i.id))
      : (this.variantIdField.disabled = !0),
      this.onVariantSelected(i, this, e),
      this.historyState != null &&
        this.historyState.onVariantChange(i, this, e);
  }),
  (window.Shopify.OptionSelectorsFromDOM = function (t, e) {
    const o = e.optionNames || [];
    const i = e.priceFieldExists || !0;
    const r = e.delimiter || "/";
    const n = this.createProductFromSelector(t, o, i, r);
    (e.product = n),
      window.Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, t, e);
  }),
  window.Shopify.extend(
    window.Shopify.OptionSelectorsFromDOM,
    window.Shopify.OptionSelectors
  ),
  (window.Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector =
    function (t, e, o, i) {
      if (!window.Shopify.isDefined(o)) var o = !0;
      if (!window.Shopify.isDefined(i)) var i = "/";
      const r = document.getElementById(t);
      const n = r.childNodes;
      let a = (r.parentNode, e.length);
      const s = [];
      window.Shopify.each(n, (t, r) => {
        if (t.nodeType == 1 && t.tagName.toLowerCase() == "option") {
          const n = t.innerHTML.split(new RegExp(`\\s*\\${i}\\s*`));
          e.length == 0 && (a = n.length - (o ? 1 : 0));
          const p = n.slice(0, a);
          const l = o ? n[a] : "";
          const c =
            (t.getAttribute("value"),
            {
              available: t.disabled ? !1 : !0,
              id: parseFloat(t.value),
              price: l,
              option1: p[0],
              option2: p[1],
              option3: p[2],
            });
          s.push(c);
        }
      });
      const p = { variants: s };
      if (e.length == 0) {
        p.options = [];
        for (let l = 0; a > l; l++) p.options[l] = `option ${l + 1}`;
      } else p.options = e;
      return p;
    }),
  (window.Shopify.SingleOptionSelector = function (t, e, o, i) {
    (this.multiSelector = t),
      (this.values = i),
      (this.index = e),
      (this.name = o),
      (this.element = document.createElement("select"));
    for (let r = 0; r < i.length; r++) {
      const n = document.createElement("option");
      (n.value = i[r]), (n.innerHTML = i[r]), this.element.appendChild(n);
    }
    return (
      this.element.setAttribute("class", this.multiSelector.selectorClass),
      this.element.setAttribute("data-option", `option${e + 1}`),
      (this.element.id = `${t.domIdPrefix}-option-${e}`),
      (this.element.onchange = function (o, i) {
        (i = i || {}), t.updateSelectors(e, i);
      }),
      !0
    );
  }),
  (window.Shopify.Image = {
    preload(t, e) {
      for (let o = 0; o < t.length; o++) {
        const i = t[o];
        this.loadImage(this.getSizedImageUrl(i, e));
      }
    },
    loadImage(t) {
      new Image().src = t;
    },
    switchImage(t, e, o) {
      if (t && e) {
        const i = this.imageSize(e.src);
        const r = this.getSizedImageUrl(t.src, i);
        o ? o(r, t, e) : (e.src = r);
      }
    },
    imageSize(t) {
      const e = t.match(
        /_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./
      );
      return e != null ? e[1] : null;
    },
    getSizedImageUrl(t, e) {
      if (e == null) return t;
      if (e == "master") return this.removeProtocol(t);
      const o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
      if (o != null) {
        const i = t.split(o[0]);
        const r = o[0];
        return this.removeProtocol(`${i[0]}_${e}${r}`);
      }
      return null;
    },
    removeProtocol(t) {
      return t.replace(/http(s)?:/, "");
    },
  }),
  (window.Shopify.OptionSelectors.HistoryState = function (t) {
    this.browserSupports() && this.register(t);
  }),
  (window.Shopify.OptionSelectors.HistoryState.prototype.register = function (
    t
  ) {
    window.addEventListener("popstate", (e) => {
      t.selectVariantFromParamsOrDropdown({ popStateCall: !0 });
    });
  }),
  (window.Shopify.OptionSelectors.HistoryState.prototype.onVariantChange =
    function (t, e, o) {
      this.browserSupports() &&
        (!t ||
          o.initialLoad ||
          o.popStateCall ||
          window.Shopify.setParam("variant", t.id));
    }),
  (window.Shopify.OptionSelectors.HistoryState.prototype.browserSupports =
    function () {
      return window.history && window.history.replaceState;
    });

$(document).on("shopify:block:select", (e) => {
  const { blockId } = e.detail;
  const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

  if (
    $parentSection.hasClass("shopify-section--slideshow") ||
    $parentSection.hasClass("shopify-section--testimonials") ||
    $parentSection.hasClass("shopify-section--shoppable-image--slider-enabled")
  ) {
    sliderBlock.select(blockId, $parentSection);
  }
});

$(document).on("shopify:block:deselect", (e) => {
  const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

  if (
    $parentSection.hasClass("shopify-section--slideshow") ||
    $parentSection.hasClass("shopify-section--testimonials")
  ) {
    window.sliderBlock.deselect($parentSection);
  }
});

$(document).on("shopify:section:reorder", (e) => {
  window.utils.initializeSectionWrapper();
});

$(document).on("shopify:section:load", (e) => {
  const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

  window.utils.initializeSectionWrapper();
  window.utils.enableDisclosure();

  if (window.PXUTheme.theme_settings.enable_autocomplete) {
    window.searchAutocomplete.init();
  }

  if (window.PXUTheme.theme_settings.newsletter_popup) {
    window.newsletter_popup.init();
  }

  if ($parentSection.hasClass("shopify-section--article-template")) {
    window.sidebarAccordions.init();
  }

  if ($parentSection.hasClass("shopify-section--blog-template")) {
    window.sidebarAccordions.init();
  }

  if ($parentSection.hasClass("shopify-section--product-sidebar")) {
    window.sidebarAccordions.init();
  }

  if ($parentSection.hasClass("shopify-section--page-gallery-template")) {
    window.gallery.init($parentSection);
  }

  if ($parentSection.hasClass("shopify-section--gallery")) {
    window.gallery.init();
  }

  if (
    $parentSection.hasClass("shopify-section--page-faq-template") ||
    $parentSection.hasClass("shopify-section--faq")
  ) {
    window.accordion.init();
  }

  if ($parentSection.hasClass("shopify-section--cart-template")) {
    window.cart.init();
  }

  if ($parentSection.hasClass("shopify-section--featured-promotions")) {
    window.featuredPromotions.init();
  }

  if ($parentSection.hasClass("shopify-section--slideshow")) {
    window.slideshow.init();
  }

  if ($parentSection.hasClass("shopify-section--testimonials")) {
    window.testimonials.init();
  }

  if ($parentSection.hasClass("shopify-section--featured-product")) {
    window.productPage.init();
    window.productPage.runOptionSelector($parentSection);
    window.videoFeature.init();
    window.productPage.productSwatches();
  }

  if ($parentSection.hasClass("shopify-section--map")) {
    window.map.init();
  }

  if ($parentSection.hasClass("shopify-section--logo-list")) {
    window.logoList.init();
  }

  if ($parentSection.hasClass("shopify-section--shoppable-image")) {
    window.shoppableImage.init();
  }

  if ($parentSection.hasClass("shopify-section--featured-collection")) {
    window.featuredCollection.init();
    window.productPage.init();
    window.productPage.runOptionSelector($parentSection);
    window.videoFeature.init();
  }

  if ($parentSection.hasClass("shopify-section--video")) {
    window.video.init();
  }

  if (
    $parentSection.hasClass("shopify-section--product-template") ||
    $parentSection.hasClass("shopify-section--quick-shop")
  ) {
    window.productPage.init();
    window.productPage.runOptionSelector($parentSection);
    window.videoFeature.init();
    window.productPage.productSwatches();
    window.recentlyViewed.init();
  }

  if ($parentSection.hasClass("shopify-section--recommended-products")) {
    window.productPage.init();
  }

  if ($parentSection.hasClass("shopify-section--recently-viewed-products")) {
    window.recentlyViewed.init();
  }

  if ($parentSection.hasClass("shopify-section--article-template")) {
    if (window.location.pathname.indexOf("/comments") != -1) {
      $("html,body").animate(
        { scrollTop: $("#new-comment").offset().top - 140 },
        "slow"
      );
    }
  }

  if ($parentSection.hasClass("shopify-section--collection-template")) {
    window.collectionSidebarFilter.init();
    window.productPage.init();
    window.productPage.runOptionSelector($parentSection);
    window.sidebarAccordions.init();
    window.recentlyViewed.init();
  }

  if ($parentSection.hasClass("shopify-section--contact-section")) {
    window.map.init();
  }

  if ($parentSection.hasClass("shopify-section--search-template")) {
    if (window.PXUTheme.theme_settings.enable_autocomplete) {
      window.searchAutocomplete.init();
    }
    window.collectionSidebarFilter.init();
    window.sidebarAccordions.init();
  }

  if ($parentSection.hasClass("shopify-section--header")) {
    window.meganavManager.injectAll();
    window.header.init();
  }

  if ($parentSection.hasClass("shopify-section--mega-menu")) {
    window.meganavManager.add($parentSection[0]);
  }
});

$(document).on("shopify:section:unload", (e) => {
  const $target = $(e.target);
  const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

  if ($parentSection.hasClass("shopify-section--header")) {
    window.header.unload($target);
  }

  if ($parentSection.hasClass("shopify-section--slideshow")) {
    window.slideshow.unload($target);
  }

  if ($parentSection.hasClass("shopify-section--logo-list")) {
    window.logoList.unload($parentSection.find("[data-logo-wrapper]"));
  }

  if ($parentSection.hasClass("shopify-section--testimonials")) {
    window.testimonials.unload($target);
  }

  if ($parentSection.hasClass("shopify-section--shoppable-image")) {
    window.shoppableImage.unload($target);
  }

  if ($parentSection.hasClass("shopify-section--search")) {
    window.searchAutocomplete.unload($target);
  }

  if ($parentSection.hasClass("shopify-section--product-template")) {
    window.productPage.unload($parentSection);
  }

  if ($parentSection.hasClass("shopify-section--featured-product")) {
    window.productPage.unload($parentSection);
  }

  if ($parentSection.hasClass("shopify-section--mega-menu")) {
    window.meganavManager.remove($parentSection[0]);
  }

  // When sections are removed from the DOM, reinitialize the section wrapper
  window.requestAnimationFrame(() => {
    window.utils.initializeSectionWrapper();
  });
});

$(document).on("shopify:section:select", (e) => {
  const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

  if ($parentSection.hasClass("shopify-section--mega-menu")) {
    window.meganavManager.select($parentSection[0]);
  }

  if ($parentSection.hasClass("shopify-section--logo-list")) {
    window.logoList.init();
  }

  if ($parentSection.hasClass("shopify-section--featured-collection")) {
    window.featuredCollection.unload($parentSection);
    window.featuredCollection.init();
  }

  const evt = document.createEvent("UIEvents");
  evt.initUIEvent("resize", true, false, window, 0);
  window.dispatchEvent(evt);
});

$(document).on("shopify:section:deselect", (e) => {
  const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

  if ($parentSection.hasClass("shopify-section--mega-menu")) {
    window.meganavManager.deselect();
  }
});

//////////////////////////////////////////////
/////////// Cart Sample Modal start /////////
////////////////////////////////////////////

const selects = document.querySelectorAll('.cart__qty-select');
selects.forEach(select => {
  select.addEventListener('change', () => {
    const intervalId = setInterval(() => {
      var modal = document.querySelector('section.cart');
      if (modal?.classList.contains('cart-sample-active')) {
        clearInterval(intervalId);
        setFocusInModal();
      }
    }, 500); // Run every 500 milliseconds (0.5 seconds)
  });
});

// function setFocusInModal(){

//   var modalParents = document.querySelectorAll('.cart-sample__container'); // Replace with the class or ID of your modal container
//   var modal = document.querySelector('section.cart'); // Replace with the class or ID of your modal container
//   var closeButton = document.querySelector('.cart-sample__close'); // Replace with the class or ID of your close button
//   var overlay = document.querySelector('.cart-sample-overlay'); // Replace with the class or ID of your overlay
//   var noThanksButton = document.querySelector('.cart-sample-no-thanks__button'); // Replace with the class or ID of your "No Thanks" button

//   // Keep track of the previously focused element
//   var previousFocus = null;

//   // Function to trap the focus within the modal
//   function trapFocus(event) {
//     var focusableElements = modalParents[0].querySelectorAll('a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select');
//     var firstFocusable = focusableElements[0];
//     var lastFocusable = focusableElements[focusableElements.length - 1];
//     var isTabPressed = (event.key === 'Tab' || event.keyCode === 9);
//     var FocusEntirePart = document.querySelector('.cart-sample-content');
//     var FocusModalCLoseElement = document.querySelector('.cart-sample__close');
    
//     if (!isTabPressed) {
//       return;
//     }

//     if (event.shiftKey) {
//       // If Shift+Tab is pressed and the currently focused element is the first focusable element within the modal, focus the last focusable element
//       if (document.activeElement === firstFocusable || document.activeElement === closeButton) {
        
//         event.preventDefault();
//         lastFocusable.focus();
//       }
//       if(document.activeElement === FocusEntirePart){
//         event.preventDefault();
//         FocusModalCLoseElement.focus();
//       }
//     } else {
//       // If Tab is pressed and the currently focused element is the last focusable element within the modal, focus the close button
//       if (document.activeElement === lastFocusable) {
//         event.preventDefault();
//         closeButton.focus();
//       }
//     }
//   }

//   function setInitialFocus() {
//     // Check if modalParents has elements
//     if (!modalParents || modalParents.length === 0) {
//       console.error('No modal parent elements found.');
//       return;
//     }
  
//     // Get the first modal parent
//     var firstModalParent = modalParents[0];
  
//     // Query focusable elements within the first modal parent
//     var focusableElements = firstModalParent.querySelectorAll(
//       'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select'
//     );
  
//     if (focusableElements.length === 0) {
//       console.error('No focusable elements found in the first modal parent.');
//       return;
//     }
  
//     // Focus on the first focusable element
//     focusableElements[0].focus();
//   }
  

//   // Function to restore focus on modal close
//   function restoreFocus() {
//     if (previousFocus && previousFocus.length) {
//       previousFocus.focus();
//     }
//   }

//   // Function to close the modal
//   function closeModal() {
//     modal.classList.remove('cart-sample-active');
//     closeButton.removeAttribute('tabindex');
//     // Remove the focus trap and restore the focus
//     document.removeEventListener('keydown', trapFocus);
//     restoreFocus();
//   }

//   // Check if the modal is open on page load
//   if (modal?.classList.contains('cart-sample-active')) {
//     previousFocus = document.activeElement; // Save the currently focused element
//     // Trap the focus within the modal
//     document.addEventListener('keydown', trapFocus);

//     // Set the initial focus within the modal
//     setInitialFocus();

//     setTimeout(function() {
//       closeButton.focus();
//       closeButton.setAttribute('tabindex','-1');
//     }, 100);
//   }

//   // Open the modal
//   const toggleCartSampleElement = document.querySelectorAll('[data-cart-sample-toggle]')[0];
//   if (toggleCartSampleElement) {
//     toggleCartSampleElement.addEventListener('click', function() {
//       previousFocus = document.activeElement; // Save the currently focused element

//       // Trap the focus within the modal
//       document.addEventListener('keydown', trapFocus);

//       // Set the initial focus within the modal
//       setInitialFocus();

//       modal.classList.add('cart-sample-active');

//       if(closeButton){
//         setTimeout(function() {
//           closeButton.focus();
//         }, 100);
//       }
//     });
//   }


//   // Close the modal
//   closeButton?.addEventListener('click', closeModal);
//   overlay?.addEventListener('click', closeModal);
//   noThanksButton?.addEventListener('click', closeModal);

// }
// document.addEventListener("DOMContentLoaded", function() {
//   setFocusInModal();
// });

//////////////////////////////////////////////
/////////// Cart Sample Modal End ///////////
////////////////////////////////////////////

$(document).ready(function () {

  $('.mini_cart').click(function (event) {

      if ($('body').hasClass('cart')) {

      }else{
          event.preventDefault();
          $('html').addClass('cart-active');
          //scroll the cart to the top
          const cartContentb = document.querySelector('.cart_content');
            if (cartContentb && typeof cartContentb.scrollTo === 'function') {
              cartContentb.scrollTo(0,0);
            }
      }

      // if($('#menu-button-triggler [data-mobile-menu-icon]').hasClass('open')){
      //   console.log("This element has the class 'open'.");
      // }else{
      //   console.log("This element does not have the class 'open'.");
      // }
  })

  $('[data-cart-toggle]').click(function (event) {
      event.preventDefault();
      $('html').toggleClass('cart-active');
      //scroll the cart to the top
      const cartContentc = document.querySelector('.cart_content');
      if (cartContentc && typeof cartContentc.scrollTo === 'function') {
        cartContentc.scrollTo(0,0);
      }

      $(this).parents('.main-nav').find('.mini_cart').focus();
      document.documentElement.classList.remove('embroidery-hidden-overflow');
  })
  
  $(document).keydown(function (event) {
    if (event.keyCode === 27 && $('html').hasClass('cart-active')) {
      // ESC Key pressed and 'html' has 'cart-active' class
      $('html').removeClass('cart-active');
      $(this).parents('.main-nav').find('.mini_cart').blur();
    }
  });
})

const contactLink = document.querySelector('a[href="/pages/contact"]');

// Add a click event listener to the contact link
if (window.location.href.includes("/pages/contact")) {
  
  var checkFormInterval = setInterval(checkFormErrors, 1000);
}

//Uncomment this for Issue 184
function checkFormErrors() {
  // Find the form element
  const form = document.querySelector('#contact_form');

  // Find the error message list (ul) and all its list items (li)
  const errorsList = form.querySelector('div.errors ul');
  const errors = errorsList.querySelectorAll('li');
  
  if (errors.length > 0) {
    clearInterval(checkFormInterval);
    // Loop through each error message
    errors.forEach(error => {
      // Check if the error message mentions email or name
      const errorText = error.innerText;
      if (errorText.includes('Email')) {
        
        // If the error is related to email, find the email input element and add aria-describedby attribute
        const emailInput = form.querySelector('input[name="contact[email]"]');
        emailInput?.setAttribute('aria-describedby', 'Email-is-Invalid');
        error.setAttribute('id','Email-is-Invalid')
        
        // Shift the focus to the email input element
        emailInput.focus();
      } else if (errorText.includes('Name')) {
        // If the error is related to name, find the name input element and add aria-describedby attribute
        const nameInput = form.querySelector('input[name="contact[name]"]');
        nameInput?.setAttribute('aria-describedby', 'Name-is-Invalid');
        error.setAttribute('id','Name-is-Invalid')
        
        // Shift the focus to the name input element
        nameInput.focus();
      } else if (errorText.includes('Message')) {
        // If the error is related to name, find the name input element and add aria-describedby attribute
        const messageInput = form.querySelector('input[name="contact[body]"]');
        messageInput?.setAttribute('aria-describedby', 'Message-is-Invalid');
        error.setAttribute('id','Message-is-Invalid')
        
        // Shift the focus to the name input element
        messageInput.focus();
    };
  })
}
}
// Set up a setInterval function that will continuously check for form errors


const tables = document.querySelectorAll('.page__content table');

// Loop through each table
tables.forEach(table => {
  // Get all the strong elements within the table body
  const strongs = table.querySelectorAll('tbody strong');
  
  // Loop through each strong element and wrap it in a th element
  strongs.forEach(strong => {
    const parentCell = strong.closest('td');
    const newHeader = document.createElement('th');
    newHeader.setAttribute('scope', 'col');
    parentCell.replaceWith(newHeader);
    newHeader.appendChild(strong);
    newHeader.style.width = '249px';
    

   
  });
});


//Get the element that you want to focus on
          
// setTimeout(function() {
  
//   const drawerWrap = document.querySelector('.header .cart_content form');
//   const firstFocusableElementCartDrawer = drawerWrap?.querySelector('.minicart__close');
//   const lastFocusableElementCartDrawer = drawerWrap?.querySelector('button.minicart__checkout');
//   const CartDrawerEmptyCloseButton = document?.querySelector('.header .cart_content .minicart__close.empty-cart-close');
//   // document?.querySelector('.cart-drawer-sample__cta button.minicart__checkout')
//   console.log('firstFocusableElementCartDrawer', firstFocusableElementCartDrawer);
//   console.log('lastFocusableElementCartDrawer', lastFocusableElementCartDrawer);
//   console.log('CartDrawerEmptyCloseButton', CartDrawerEmptyCloseButton);

//   function trapFocus(event) {
//     const TAB_KEYCODE = 9;

//     if (event.key === 'Tab') {
//       if (event.shiftKey) {
//         // If the shift key is pressed with the tab key
//         if (event.target == firstFocusableElementCartDrawer) {
//           event.preventDefault();
//           lastFocusableElementCartDrawer.focus();
//         }
//       } else {
//         // If only the tab key is pressed
//         if (event.target == lastFocusableElementCartDrawer) {
//           event.preventDefault();
//           firstFocusableElementCartDrawer.focus();
//         }
//         else if (event.target == CartDrawerEmptyCloseButton) {
//           event.preventDefault();
//           CartDrawerEmptyCloseButton.focus();
//         }
//       }
//     }

    
//   }

//   // firstFocusableElementCartDrawer?.addEventListener('keydown', trapFocus);
//   // lastFocusableElementCartDrawer?.addEventListener('keydown', trapFocus);
//   // CartDrawerEmptyCloseButton?.addEventListener('keydown', trapFocus);

//   drawerWrap?.addEventListener('keydown', trapFocus);

// }, 100);
// Comprehensive Focus Trap Logic for Cart Drawer and Sample Drawer
setTimeout(function() {
  
  // Main Cart Drawer Elements
  const mainCartDrawer = document.querySelectorAll('.header .cart_content')[0];
  const emptyCartCloseButton = document.querySelectorAll('.header .cart_content .minicart__close.empty-cart-close')[0];
  
  // Sample Drawer Elements
  const sampleDrawer = document.querySelectorAll('.cart-drawer-sample')[1];
  const sampleDrawerCloseButton = document.querySelectorAll('.cart-drawer-sample button.cart-drawer-sample__close')[1];
  const sampleDrawerCheckoutButton = document.querySelectorAll('.cart-drawer-sample button.minicart__checkout')[1];
  
  // Main Cart Drawer Form Elements (when cart has products)
  const mainCartForm = document.querySelectorAll('.cart_content form')[1];
  
  // Function to get all focusable elements in the cart form dynamically
  function getCartFocusableElements() {
    if (!mainCartForm) return { first: null, last: null };
    
    const focusableElements = mainCartForm.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    
    // Filter out hidden or disabled elements
    const visibleFocusableElements = Array.from(focusableElements).filter(el => 
      el.offsetParent !== null && 
      !el.disabled && 
      !el.hasAttribute('disabled')
    );
    
    return {
      first: visibleFocusableElements[0] || null,
      last: visibleFocusableElements[visibleFocusableElements.length - 1] || null,
      all: visibleFocusableElements
    };
  }
  const focusableElements = getCartFocusableElements();
 
  function handleMainCartFocusTrap(event) {
    if (event.key !== 'Tab') return;

    // Sample drawer handles its own trap and hides the main cart while open.
    if (document.querySelector('.cart-drawer-sample.cart-drawer-sample-open')) {
      return;
    }
    
    // Case 1: Empty cart - only close button is focusable
    if (emptyCartCloseButton && emptyCartCloseButton.offsetParent !== null) {
      if (event.target === emptyCartCloseButton) {
        event.preventDefault();
        emptyCartCloseButton.focus();
      }
      return;
    }
    
    // Case 2: Cart with products - get fresh focusable elements (handles dynamic content like LimeSpot)
    const currentFocusableElements = getCartFocusableElements();
    
    if (currentFocusableElements.first && currentFocusableElements.last) {
      if (event.shiftKey) {
        // Shift + Tab - going backwards
        if (event.target === currentFocusableElements.first) {
          event.preventDefault();
          currentFocusableElements.last.focus();
        }
      } else {
        // Tab - going forwards
        if (event.target === currentFocusableElements.last) {
          event.preventDefault();
          currentFocusableElements.first.focus();
        }
      }
    }
  }

  function handleSampleDrawerFocusTrap(event) {
    // Full sample-drawer focus trap lives in snippets/cart-drawer-js.liquid.
    return;
  }

  // Add event listeners to main cart drawer
  if (mainCartDrawer) {
    mainCartDrawer.addEventListener('keydown', handleMainCartFocusTrap);
  }
  
  // Add event listeners to sample drawer
  if (sampleDrawer) {
    sampleDrawer.addEventListener('keydown', handleSampleDrawerFocusTrap);
  }

}, 100); 

// Handle click on embroidery edit link in cart (embroidery editing functionality)
document.addEventListener('click', function(e) {
  // Check if clicked element is an embroidery edit link or a child of it
  const editLink = e.target.closest('.embroidery-edit-link');
  if (editLink) {
    e.preventDefault();
    
    // Get the sync code from the data attribute
    const syncCode = editLink.getAttribute('data-embroidery-edit');
    
    if (syncCode) {
      // Get the cart item element
      const cartItem = editLink.closest('[data-cart-item]');
      if (!cartItem) return;
      
      // Find the embroidery text in the DOM - it should be in the embroidery properties
      const embroideryText = editLink.getAttribute('data-embroidery-text') || '';
      
      // Get the product URL from the cart item title link
      const productLink = cartItem.querySelector('.mini-cart__item-product-title');
      if (productLink && productLink.href) {
        // Get current page URL (without parameters) and product URL for comparison
        const currentPagePath = window.location.pathname;
        const productUrl = new URL(productLink.href);
        const productPath = productUrl.pathname;
        
        // Check if we're already on the same product page
        if (currentPagePath === productPath) {
          console.log('Already on the same product page, opening modal directly');
          
          // Close the cart drawer first
          document.documentElement.classList.remove('cart-active');
          
          // Find the embroidery modal
          const embroideryModal = document.getElementById('embroidery-modal-wrapper');
          if (embroideryModal) {
            // Pre-fill the embroidery input with the current text
            const nameInput = document.getElementById('name-input');
            if (nameInput) {
              nameInput.value = embroideryText;
              // Trigger the input event to update the preview and character count
              const inputEvent = new Event('input', { bubbles: true });
              nameInput.dispatchEvent(inputEvent);
            }
            
            // Show the modal
            embroideryModal.classList.remove('embroidery-hidden');
            document.body.classList.add('embroidery-hidden-overflow');
            document.documentElement.classList.add('embroidery-hidden-overflow');
            
            // Add sync code and edit mode to URL without reloading the page
            const newUrl = new URL(window.location.href);
            newUrl.searchParams.set('embroidery', embroideryText);
            newUrl.searchParams.set('sync', syncCode);
            newUrl.searchParams.set('editmode', 'true');
            window.history.replaceState({}, '', newUrl);
          } else {
            console.error('Embroidery modal not found, falling back to redirect');
            // Fall back to redirect if modal not found
            performRedirect();
          }
        } else {
          // Not on the same page, perform the regular redirect
          performRedirect();
        }
        
        // Helper function to handle redirect logic
        function performRedirect() {
          // Create the URL with the embroidery parameter and sync code for edit mode
          let redirectUrl = productLink.href;
          
          // Check if URL already has parameters
          if (redirectUrl.includes('?')) {
            // URL already has parameters, append with &
            redirectUrl += `&embroidery=${encodeURIComponent(embroideryText)}&sync=${encodeURIComponent(syncCode)}&editmode=true`;
          } else {
            // URL has no parameters, use ? to start query string
            redirectUrl += `?embroidery=${encodeURIComponent(embroideryText)}&sync=${encodeURIComponent(syncCode)}&editmode=true`;
          }
          
          // Close the cart drawer before redirecting
          document.documentElement.classList.remove('cart-active');
          
          // Navigate to the product page
          window.location.href = redirectUrl;
        }
      }
    }
  }
});


